/**
 * CATÁLOGO DE PRODUCTOS MEALCYCLE v4.0 (EDICIÓN OPTIMIZADA ARGENTINA)
 * ✅ 520 productos con unidades adaptadas a la compra real y cotidiana.
 * ✅ Motor de búsqueda potenciado: Sistema de 'keywords' (marcas, sinónimos y modismos) para Fuzzy Match.
 * * NUEVAS REGLAS APLICADAS (Basadas en la UX del supermercado):
 * 1. Carnes, Verduras a granel y Frutas a granel: Default 'kg' (Secundaria: 'g').
 * 2. Fiambres y Quesos de fiambrería: Default 'g' (La gente pide "200g", no "0.2kg").
 * 3. Legumbres, Cereales, Snacks, Harinas, Congelados: Default 'paquete' (Secundarias: 'kg', 'g').
 * 4. Bebidas y Lácteos líquidos: Default 'l' o 'unidad' (sachet/botella/lata).
 * 5. Limpieza e Higiene Personal: Default 'unidad' (Secundarias: 'l', 'ml' para especificar volumen).
 * 6. Huevos: ['unidad', 'docena', 'maple'].
 * 7. Despensa (Salsas, aderezos, latas, mermeladas): Default 'unidad' (latas, frascos, cajas).
 */

// ============================================
// VERDURAS (61 productos) ✅ LIMPIO & OPTIMIZADO PARA BUSCADOR
// ============================================
const VERDURAS = [
  // A GRANEL (kg, g)
  {
    id: 'prod_v001',
    name: 'Tomate',
    category: 'verduras',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🍅',
    description: 'Tomate perita o redondo',
    keywords: ['jitomate', 'tomate redondo', 'tomate para ensalada']
  },
  {
    id: 'prod_v002',
    name: 'Cebolla',
    category: 'verduras',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🧅',
    description: 'Cebolla común',
    keywords: ['cebollita', 'cebolla blanca', 'cebolla comun']
  },
  {
    id: 'prod_v003',
    name: 'Papa',
    category: 'verduras',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥔',
    description: 'Papa común',
    keywords: ['patata', 'papa negra', 'papa blanca', 'papa lavada']
  },
  {
    id: 'prod_v004',
    name: 'Batata',
    category: 'verduras',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🍠',
    description: 'Batata o camote',
    keywords: ['boniato', 'camote']
  },
  {
    id: 'prod_v005',
    name: 'Zanahoria',
    category: 'verduras',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🥕',
    description: 'Zanahoria fresca',
    keywords: []
  },
  
  // POR PIEZA (unidad, kg, g)
  {
    id: 'prod_v006',
    name: 'Lechuga',
    category: 'verduras',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'kg', 'g'],
    icon: '🥬',
    description: 'Lechuga manteca o criolla',
    keywords: ['lechuga manteca', 'lechuga repollada', 'lechuga francesa']
  },
  
  // A GRANEL
  {
    id: 'prod_v007',
    name: 'Zapallo',
    category: 'verduras',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🎃',
    description: 'Zapallo criollo o plomo',
    keywords: ['zapallo plomo', 'zapallo coreano']
  },
  {
    id: 'prod_v008',
    name: 'Zapallito',
    category: 'verduras',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥒',
    description: 'Zapallito redondo o verde',
    keywords: ['zapallito verde', 'zapallito redondo', 'zapallitos']
  },
  
  // POR PIEZA
  {
    id: 'prod_v009',
    name: 'Morrón',
    category: 'verduras',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'kg', 'g'],
    icon: '🫑',
    description: 'Rojo, verde o amarillo',
    keywords: ['pimiento', 'pimiento rojo', 'pimiento verde', 'morron rojo', 'morron verde']
  },
  {
    id: 'prod_v010',
    name: 'Ají',
    category: 'verduras',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'g'],
    icon: '🌶️',
    description: 'Ají picante o dulce',
    keywords: ['chile', 'aji putapario', 'aji limo', 'aji molido']
  },
  
  // A GRANEL
  {
    id: 'prod_v011',
    name: 'Berenjena',
    category: 'verduras',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🍆',
    description: 'Berenjena común',
    keywords: []
  },
  
  // POR PIEZA
  {
    id: 'prod_v012',
    name: 'Pepino',
    category: 'verduras',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'kg', 'g'],
    icon: '🥒',
    description: 'Pepino fresco para ensalada',
    keywords: []
  },
  
  // A GRANEL / ATADOS
  {
    id: 'prod_v013',
    name: 'Acelga',
    category: 'verduras',
    defaultUnit: 'unidad', // En Argentina se suele comprar por paquete/atado
    commonUnits: ['unidad', 'kg'],
    icon: '🥬',
    description: 'Atado de acelga fresca',
    keywords: ['atado de acelga', 'paquete de acelga']
  },
  {
    id: 'prod_v014',
    name: 'Espinaca',
    category: 'verduras',
    defaultUnit: 'unidad', // Atado o paquete
    commonUnits: ['unidad', 'kg', 'g'],
    icon: '🥬',
    description: 'Atado de espinaca fresca',
    keywords: ['atado de espinaca']
  },
  {
    id: 'prod_v015',
    name: 'Brócoli',
    category: 'verduras',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🥦',
    description: 'Brócoli fresco',
    keywords: ['brocoli']
  },
  
  // POR PIEZA
  {
    id: 'prod_v016',
    name: 'Coliflor',
    category: 'verduras',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'kg', 'g'],
    icon: '🥦',
    description: 'Coliflor fresca',
    keywords: []
  },
  {
    id: 'prod_v017',
    name: 'Repollo',
    category: 'verduras',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'kg', 'g'],
    icon: '🥬',
    description: 'Blanco o colorado',
    keywords: ['col', 'repollo blanco', 'repollo colorado', 'repollo morado']
  },
  {
    id: 'prod_v018',
    name: 'Choclo',
    category: 'verduras',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'kg', 'g'],
    icon: '🌽',
    description: 'Choclo fresco en espiga',
    keywords: ['maíz', 'elote', 'espiga de choclo']
  },
  
  // A GRANEL
  {
    id: 'prod_v019',
    name: 'Remolacha',
    category: 'verduras',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🥕',
    description: 'Remolacha fresca',
    keywords: ['betabel']
  },
  
  // POR PIEZA
  {
    id: 'prod_v020',
    name: 'Ajo',
    category: 'verduras',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'kg', 'g'],
    icon: '🧄',
    description: 'Cabeza de ajo común',
    keywords: ['cabeza de ajo', 'diente de ajo']
  },
  
  // A GRANEL
  {
    id: 'prod_v021',
    name: 'Jengibre',
    category: 'verduras',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🫚',
    description: 'Raíz de jengibre fresco',
    keywords: []
  },
  
  // POR PIEZA
  {
    id: 'prod_v022',
    name: 'Puerro',
    category: 'verduras',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'kg', 'g'],
    icon: '🧅',
    description: 'Puerro fresco',
    keywords: ['porro']
  },
  {
    id: 'prod_v023',
    name: 'Apio',
    category: 'verduras',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'kg', 'g'],
    icon: '🌿',
    description: 'Planta de apio',
    keywords: []
  },
  {
    id: 'prod_v024',
    name: 'Perejil',
    category: 'verduras',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'g'],
    icon: '🌿',
    description: 'Atadito de perejil fresco',
    keywords: ['atado de perejil']
  },
  {
    id: 'prod_v025',
    name: 'Cilantro',
    category: 'verduras',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'g'],
    icon: '🌿',
    description: 'Atadito de cilantro fresco',
    keywords: ['atado de cilantro']
  },
  {
    id: 'prod_v026',
    name: 'Albahaca',
    category: 'verduras',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'g'],
    icon: '🌿',
    description: 'Planta o atadito de albahaca fresca',
    keywords: ['pesto']
  },
  
  // A GRANEL / ATADOS
  {
    id: 'prod_v027',
    name: 'Rúcula',
    category: 'verduras',
    defaultUnit: 'unidad', // Generalmente por atado
    commonUnits: ['unidad', 'kg', 'g'],
    icon: '🥬',
    description: 'Atado de rúcula fresca',
    keywords: ['arúgula', 'atado de rucula']
  },
  {
    id: 'prod_v028',
    name: 'Radicheta',
    category: 'verduras',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'kg', 'g'],
    icon: '🥬',
    description: 'Atado de radicheta fresca',
    keywords: []
  },
  {
    id: 'prod_v029',
    name: 'Espárrago',
    category: 'verduras',
    defaultUnit: 'unidad', // Atado
    commonUnits: ['unidad', 'kg', 'g'],
    icon: '🌱',
    description: 'Atado de espárragos frescos',
    keywords: ['esparragos']
  },
  {
    id: 'prod_v030',
    name: 'Hongos',
    category: 'verduras',
    defaultUnit: 'g', // Se compran en bandejitas de gramos
    commonUnits: ['g', 'kg', 'unidad'],
    icon: '🍄',
    description: 'Champiñones, portobello o pino',
    keywords: ['champiñones', 'setas', 'hongos de pino', 'portobello', 'champignon']
  },
  {
    id: 'prod_v031',
    name: 'Chaucha',
    category: 'verduras',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🫛',
    description: 'Chauchas frescas (planas o redondas)',
    keywords: ['judías verdes', 'vainitas', 'chaucha plana', 'chaucha redonda']
  },
  
  // POR PIEZA
  {
    id: 'prod_v032',
    name: 'Verdeo',
    category: 'verduras',
    defaultUnit: 'unidad', // Atado
    commonUnits: ['unidad', 'g'],
    icon: '🧅',
    description: 'Cebolla de verdeo (atadito)',
    keywords: ['cebollín', 'cebolla de verdeo', 'atado de verdeo']
  },
  {
    id: 'prod_v033',
    name: 'Rabanito',
    category: 'verduras',
    defaultUnit: 'unidad', // Atadito
    commonUnits: ['unidad', 'kg', 'g'],
    icon: '🌶️',
    description: 'Atadito de rabanitos frescos',
    keywords: []
  },
  {
    id: 'prod_v034',
    name: 'Hinojo',
    category: 'verduras',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'kg', 'g'],
    icon: '🌿',
    description: 'Hinojo fresco',
    keywords: []
  },
  
  // A GRANEL
  {
    id: 'prod_v035',
    name: 'Nabo',
    category: 'verduras',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥕',
    description: 'Nabos frescos',
    keywords: []
  },
  {
    id: 'prod_v036',
    name: 'Achicoria',
    category: 'verduras',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🥬',
    description: 'Achicoria fresca',
    keywords: []
  },
  
  // POR PIEZA
  {
    id: 'prod_v037',
    name: 'Berro',
    category: 'verduras',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'g'],
    icon: '🌿',
    description: 'Atadito de berro fresco',
    keywords: []
  },
  
  // A GRANEL
  {
    id: 'prod_v038',
    name: 'Endibia',
    category: 'verduras',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥬',
    description: 'Endibia',
    keywords: ['endivia']
  },
  
  // POR PIEZA
  {
    id: 'prod_v039',
    name: 'Lechuga capuchina',
    category: 'verduras',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'kg', 'g'],
    icon: '🥬',
    description: 'Lechuga capuchina tipo iceberg',
    keywords: ['iceberg', 'lechuga redonda']
  },
  {
    id: 'prod_v040',
    name: 'Lechuga morada',
    category: 'verduras',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'kg', 'g'],
    icon: '🥬',
    description: 'Lechuga morada o francesa',
    keywords: []
  },
  
  // A GRANEL
  {
    id: 'prod_v041',
    name: 'Cebolla morada',
    category: 'verduras',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🧅',
    description: 'Cebolla morada dulce',
    keywords: []
  },
  {
    id: 'prod_v042',
    name: 'Tomates cherry',
    category: 'verduras',
    defaultUnit: 'g', // Suelen venderse en cajitas de 250g
    commonUnits: ['g', 'kg', 'unidad'],
    icon: '🍅',
    description: 'Bandeja de tomates cherry',
    keywords: ['cherry', 'cherrys']
  },
  {
    id: 'prod_v043',
    name: 'Tomate perita',
    category: 'verduras',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🍅',
    description: 'Tomate perita para salsa o ensalada',
    keywords: []
  },
  {
    id: 'prod_v044',
    name: 'Choclo baby',
    category: 'verduras',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg', 'unidad'],
    icon: '🌽',
    description: 'Bandeja de choclo baby',
    keywords: []
  },
  
  // POR PIEZA
  {
    id: 'prod_v045',
    name: 'Alcaucil',
    category: 'verduras',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'kg', 'g'],
    icon: '🌿',
    description: 'Alcaucil fresco',
    keywords: ['alcachofa']
  },
  
  // ENLATADOS / CONSERVAS (Muchos los buscan en verduras)
  {
    id: 'prod_v046',
    name: 'Palmitos',
    category: 'verduras', // En algunos súper está en despensa
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'lata'],
    icon: '🥬',
    description: 'Palmitos en lata o frasco',
    keywords: ['lata de palmitos']
  },
    
  // POR PIEZA
  {
    id: 'prod_v047',
    name: 'Cebolla de verdeo',
    category: 'verduras',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'kg', 'g'],
    icon: '🧅',
    description: 'Cebolla de verdeo (manojo)',
    keywords: ['verdeo', 'atado de verdeo']
  },
  
  // A GRANEL
  {
    id: 'prod_v048',
    name: 'Ajíes verdes',
    category: 'verduras',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🌶️',
    description: 'Ajíes verdes',
    keywords: []
  },
  {
    id: 'prod_v049',
    name: 'Calabaza',
    category: 'verduras',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🎃',
    description: 'Calabaza tipo kabutiá',
    keywords: ['zapallo kabutiá', 'cabutia']
  },
  {
    id: 'prod_v050',
    name: 'Zapallo anco',
    category: 'verduras',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🎃',
    description: 'Zapallo anco o coreanito',
    keywords: ['coreanito']
  },
  
  // POR PIEZA (cocida al vacío)
  {
    id: 'prod_v051',
    name: 'Remolacha cocida',
    category: 'verduras',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'paquete'],
    icon: '🥕',
    description: 'Remolacha cocida al vacío',
    keywords: ['remolacha envasada']
  },
  
  // A GRANEL (congelada)
  {
    id: 'prod_v052',
    name: 'Espinaca congelada',
    category: 'verduras',
    defaultUnit: 'unidad', // Paquete
    commonUnits: ['unidad', 'kg', 'g', 'paquete'],
    icon: '🥬',
    description: 'Espinaca congelada en cubos',
    keywords: ['espinaca en cubos']
  },
  {
    id: 'prod_v053',
    name: 'Rúcula baby',
    category: 'verduras',
    defaultUnit: 'g', // Bandeja
    commonUnits: ['g', 'kg', 'unidad'],
    icon: '🥬',
    description: 'Bandeja de rúcula baby',
    keywords: []
  },
  {
    id: 'prod_v054',
    name: 'Mix de hojas verdes',
    category: 'verduras',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'g'],
    icon: '🥗',
    description: 'Bolsa de mix de ensalada',
    keywords: ['ensalada en bolsa']
  },
  {
    id: 'prod_v055',
    name: 'Kale',
    category: 'verduras',
    defaultUnit: 'unidad', // Atado
    commonUnits: ['unidad', 'kg', 'g'],
    icon: '🥬',
    description: 'Atado de kale fresco',
    keywords: ['col rizada']
  },
  {
    id: 'prod_v056',
    name: 'Col de Bruselas',
    category: 'verduras',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥬',
    description: 'Repollitos de Bruselas',
    keywords: ['repollitos de bruselas']
  },
  {
    id: 'prod_v057',
    name: 'Pak choi',
    category: 'verduras',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'kg', 'g'],
    icon: '🥬',
    description: 'Pak choi o bok choy',
    keywords: ['bok choy']
  },
  {
    id: 'prod_v058',
    name: 'Calabacín',
    category: 'verduras',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🥒',
    description: 'Calabacín o zucchini alargado',
    keywords: ['zapallito italiano', 'zucchini', 'zuccini']
  },
  
  // ENLATADOS
  {
    id: 'prod_v059',
    name: 'Pimientos asados',
    category: 'verduras', // A veces en despensa
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'frasco', 'lata'],
    icon: '🫑',
    description: 'Pimientos o morrones en conserva',
    keywords: ['morrones en frasco', 'morron en lata']
  },
  
  // A GRANEL
  {
    id: 'prod_v060',
    name: 'Tomates secos',
    category: 'verduras',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🍅',
    description: 'Tomates secos al sol',
    keywords: ['tomate desecado']
  }
];

// ============================================
// CARNES (55 productos) ✅ LIMPIO & OPTIMIZADO PARA BUSCADOR
// ============================================
const CARNES = [
  // RES / VACA
  {
    id: 'prod_c001',
    name: 'Carne picada',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥩',
    description: 'Común o especial',
    keywords: ['molida', 'picada común', 'picada especial', 'hamburguesa casera']
  },
  {
    id: 'prod_c002',
    name: 'Asado',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥩',
    description: 'Tira de asado',
    keywords: ['tira de asado', 'costillar', 'asado de tira']
  },
  {
    id: 'prod_c003',
    name: 'Vacío',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥩',
    description: 'Vacío de res',
    keywords: ['vacio', 'carne al horno']
  },
  {
    id: 'prod_c008',
    name: 'Milanesas',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥩',
    description: 'Nalga, cuadrada o bola de lomo preparadas',
    keywords: ['mila', 'milanga', 'carne para milanesa', 'nalga', 'bola de lomo', 'cuadrada']
  },
  {
    id: 'prod_c014',
    name: 'Matambre',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥩',
    description: 'De res o cerdo',
    keywords: ['matambre a la pizza', 'matambre arrollado']
  },
  {
    id: 'prod_c015',
    name: 'Entraña',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥩',
    description: 'Entraña de res',
    keywords: ['entrana']
  },
    { id: 'prod_c104', name: 'Bifes (Nalga/Cuadril)', category: 'carnes', defaultUnit: 'kg', commonUnits: ['kg', 'g'], icon: '🥩', description: 'Carne cortada para bifes', keywords: ['bife', 'nalga', 'cuadril', 'churrasco', 'carne'] },
  {
    id: 'prod_c016',
    name: 'Bife de chorizo',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥩',
    description: 'Bife ancho o angosto',
    keywords: ['bife', 'chuleta', 'entrecot']
  },
  {
    id: 'prod_c017',
    name: 'Peceto',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥩',
    description: 'Peceto de res',
    keywords: ['vitel tone', 'carne al horno']
  },
  {
    id: 'prod_c018',
    name: 'Nalga',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥩',
    description: 'Corte magro',
    keywords: ['carne para milanesa', 'feteada']
  },
  {
    id: 'prod_c019',
    name: 'Osobuco',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥩',
    description: 'Con hueso y caracú',
    keywords: ['puchero', 'carne para sopa', 'caracu']
  },
  {
    id: 'prod_c031',
    name: 'Cuadril',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥩',
    description: 'Cuadril de res',
    keywords: ['bife de cuadril']
  },
  {
    id: 'prod_c032',
    name: 'Colita de cuadril',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥩',
    description: 'Ideal para horno o parrilla',
    keywords: ['colita']
  },
  {
    id: 'prod_c033',
    name: 'Roast beef',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥩',
    description: 'Carne para guiso o estofado',
    keywords: ['rosbif', 'carne para guiso', 'estofado']
  },
  {
    id: 'prod_c034',
    name: 'Cuadrada',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥩',
    description: 'Cuadrada de res',
    keywords: ['milanesa']
  },
  {
    id: 'prod_c035',
    name: 'Paleta',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥩',
    description: 'Paleta de res',
    keywords: ['carne al horno', 'bife de paleta']
  },
  {
    id: 'prod_c036',
    name: 'Aguja',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥩',
    description: 'Aguja de res',
    keywords: ['carne picada picar', 'guisera']
  },
  {
    id: 'prod_c037',
    name: 'Falda',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥩',
    description: 'Falda de res',
    keywords: ['puchero', 'asado barato']
  },
  {
    id: 'prod_c038',
    name: 'Tapa de asado',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥩',
    description: 'Tapa de asado',
    keywords: ['carne al horno']
  },

  // POLLO / AVES
  {
    id: 'prod_c004',
    name: 'Pollo entero',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🍗',
    description: 'Fresco o congelado',
    keywords: ['pollo al horno']
  },
  {
    id: 'prod_c005',
    name: 'Pechuga de pollo',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🍗',
    description: 'Deshuesada',
    keywords: ['suprema', 'filet de pollo', 'blanco de pollo']
  },
  {
    id: 'prod_c006',
    name: 'Muslo de pollo',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🍗',
    description: 'Solo muslo',
    keywords: ['muslito']
  },
  {
    id: 'prod_c051', // NUEVO
    name: 'Pata muslo',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🍗',
    description: 'Cuarto trasero de pollo',
    keywords: ['pata y muslo', 'cuarto trasero', 'pollo']
  },
  {
    id: 'prod_c007',
    name: 'Alitas de pollo',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🍗',
    description: 'Alitas frescas',
    keywords: ['alita']
  },

  // CERDO
  {
    id: 'prod_c012',
    name: 'Costeletas de cerdo',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥩',
    description: 'Costillitas',
    keywords: ['costilla de cerdo', 'chuleta de cerdo']
  },
  {
    id: 'prod_c052', // NUEVO
    name: 'Pechito de cerdo',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥩',
    description: 'Pechito con o sin manta',
    keywords: ['pechito', 'cerdo al horno']
  },
  {
    id: 'prod_c053', // NUEVO
    name: 'Carré de cerdo',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥩',
    description: 'Deshuesado',
    keywords: ['carre', 'bife de cerdo', 'lomito de cerdo']
  },
  {
    id: 'prod_c013',
    name: 'Bondiola',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥩',
    description: 'Bondiola de cerdo fresca',
    keywords: ['bondiola de cerdo', 'bondipán']
  },
  {
    id: 'prod_c046',
    name: 'Carne de cerdo',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥩',
    description: 'Para estofado o picar',
    keywords: ['pulpa de cerdo']
  },
  {
    id: 'prod_c047',
    name: 'Solomillo',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥩',
    description: 'Solomillo de cerdo o res',
    keywords: ['lomo']
  },

  // ACHURAS / EMBUTIDOS
  {
    id: 'prod_c009',
    name: 'Chorizo',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🌭',
    description: 'Parrillero, mezcla o puro cerdo',
    keywords: ['chori', 'chorizo de mezcla', 'chorizo puro cerdo']
  },
  {
    id: 'prod_c054', // NUEVO
    name: 'Salchicha parrillera',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🌭',
    description: 'Salchicha fresca para asar',
    keywords: ['parrillera']
  },
  {
    id: 'prod_c011',
    name: 'Morcilla',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🌭',
    description: 'Común o vasca/dulce',
    keywords: ['morci', 'morcilla bombón']
  },
  {
    id: 'prod_c039',
    name: 'Chinchulines',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥩',
    description: 'Chinchulines de vaca',
    keywords: ['chinchu', 'achura']
  },
  {
    id: 'prod_c040',
    name: 'Molleja',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥩',
    description: 'Molleja de res',
    keywords: ['molleja de corazon', 'molleja de cuello']
  },
  {
    id: 'prod_c029',
    name: 'Hígado',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥩',
    description: 'Hígado de res',
    keywords: ['bife de higado']
  },
  {
    id: 'prod_c030',
    name: 'Riñón',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥩',
    description: 'Riñón de res',
    keywords: ['riñones']
  },

  // RÁPIDOS / PROCESADOS
  {
    id: 'prod_c010',
    name: 'Salchicha',
    category: 'carnes',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'paquete'],
    icon: '🌭',
    description: 'Tipo viena',
    keywords: ['panchos', 'vienesas', 'salchichas']
  },
  {
    id: 'prod_c028',
    name: 'Patitas',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'caja'],
    icon: '🍗',
    description: 'Patitas o nuggets de pollo',
    keywords: ['nuggets', 'medallones de pollo', 'formitas']
  },

  // FIAMBRES (Los dejé acá porque los tenías en carnes, aunque suelen ir en Lácteos/Fiambres)
  {
    id: 'prod_c022',
    name: 'Jamón cocido',
    category: 'carnes',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🍖',
    description: 'Feteado o en trozo',
    keywords: ['fiambre', 'paleta cocida']
  },
  {
    id: 'prod_c023',
    name: 'Jamón crudo',
    category: 'carnes',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🍖',
    description: 'Feteado',
    keywords: ['fiambre']
  },
  {
    id: 'prod_c024',
    name: 'Salame',
    category: 'carnes',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg', 'unidad'],
    icon: '🍖',
    description: 'Milán, picado fino o grueso',
    keywords: ['salamin', 'picado fino', 'picado grueso']
  },
  {
    id: 'prod_c025',
    name: 'Mortadela',
    category: 'carnes',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🍖',
    description: 'Feteada',
    keywords: ['fiambre']
  },
  {
    id: 'prod_c026',
    name: 'Panceta',
    category: 'carnes',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🥓',
    description: 'Ahumada o salada',
    keywords: ['bacon', 'tocino', 'panceta ahumada']
  },

  // PESCADOS / MARISCOS
  {
    id: 'prod_c020',
    name: 'Pescado entero',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🐟',
    description: 'Pescado fresco entero',
    keywords: ['pescado al horno']
  },
  {
    id: 'prod_c055', // NUEVO
    name: 'Filet de merluza',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🐟',
    description: 'Fresco o congelado',
    keywords: ['pescado', 'filet', 'filete']
  },
  {
    id: 'prod_c021',
    name: 'Atún enlatado',
    category: 'carnes',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'lata'],
    icon: '🥫',
    description: 'Al natural o en aceite',
    keywords: ['lata de atun']
  },
  {
    id: 'prod_c048',
    name: 'Rabas',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🦑',
    description: 'Aros de calamar',
    keywords: ['calamar']
  },
  {
    id: 'prod_c049',
    name: 'Langostinos',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🦐',
    description: 'Pelados o enteros',
    keywords: ['camarones', 'mariscos']
  },

  // OTROS (Mantenidos de tu lista original)
  {
    id: 'prod_c041',
    name: 'Chorizos criollos',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🌭',
    description: 'Chorizos criollos',
    keywords: ['chori']
  },
  {
    id: 'prod_c042',
    name: 'Morcilla vasca',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🌭',
    description: 'Con pasas y nueces',
    keywords: ['dulce']
  },
  {
    id: 'prod_c043',
    name: 'Morcilla dulce',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🌭',
    description: 'Morcilla dulce',
    keywords: ['vasca']
  },
  {
    id: 'prod_c044',
    name: 'Cordero',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥩',
    description: 'Cordero fresco',
    keywords: ['chivito']
  },
  {
    id: 'prod_c045',
    name: 'Chivo',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🥩',
    description: 'Carne de chivo',
    keywords: ['cabrito']
  },
  {
    id: 'prod_c050',
    name: 'Centolla',
    category: 'carnes',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🦀',
    description: 'Centolla',
    keywords: ['cangrejo', 'mariscos']
  }
];

// ============================================
// FIAMBRES (23 productos) ✅ LIMPIO & OPTIMIZADO PARA BUSCADOR
// ============================================
const FIAMBRES = [
  // TODOS A GRANEL (Default 'g' porque se piden por gramos en la fiambrería)
  {
    id: 'prod_fi001',
    name: 'Jamón cocido',
    category: 'fiambres',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🍖',
    description: 'Feteado o en trozo',
    keywords: ['jamon de maquina', 'fiambre', 'jamon natural']
  },
  {
    id: 'prod_fi002',
    name: 'Jamón crudo',
    category: 'fiambres',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🍖',
    description: 'Jamón crudo o serrano',
    keywords: ['serrano', 'parma', 'fiambre']
  },
  {
    id: 'prod_fi003',
    name: 'Salame',
    category: 'fiambres',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg', 'unidad'],
    icon: '🍖',
    description: 'Tipo milán, picado fino o grueso',
    keywords: ['salamin', 'picado fino', 'picado grueso', 'milan', 'salame de colonia']
  },
  {
    id: 'prod_fi004',
    name: 'Mortadela',
    category: 'fiambres',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🍖',
    description: 'Mortadela común (bocha o feteada)',
    keywords: ['bocha', 'fiambre']
  },
  {
    id: 'prod_fi005',
    name: 'Panceta',
    category: 'fiambres',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🥓',
    description: 'Panceta ahumada o salada',
    keywords: ['bacon', 'tocino', 'panceta ahumada', 'panceta salada']
  },
  {
    id: 'prod_fi006',
    name: 'Jamón de pavo',
    category: 'fiambres',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🍖',
    description: 'Blanco de pavo',
    keywords: ['pavo', 'pechuga de pavo', 'fiambre light']
  },
  {
    id: 'prod_fi007',
    name: 'Pastrón',
    category: 'fiambres',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🍖',
    description: 'Pastrón ahumado',
    keywords: ['pastrami']
  },
  {
    id: 'prod_fi008',
    name: 'Lomito',
    category: 'fiambres',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🍖',
    description: 'Lomito de cerdo cocido o ahumado',
    keywords: ['lomo ahumado', 'lomito ahumado', 'lomo horneado', 'kassel']
  },
  {
    id: 'prod_fi009',
    name: 'Leberwurst',
    category: 'fiambres',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg', 'unidad'],
    icon: '🍖',
    description: 'Leberwurst o paté',
    keywords: ['leber', 'pate', 'picadillo', 'pasta de higado']
  },
  {
    id: 'prod_fi010',
    name: 'Queso de cerdo',
    category: 'fiambres',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🍖',
    description: 'Queso de cerdo',
    keywords: ['cabeza de cerdo']
  },
  {
    id: 'prod_fi011',
    name: 'Bondiola curada',
    category: 'fiambres',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🍖',
    description: 'Bondiola curada o cocida',
    keywords: ['bondiola feteada']
  },
  {
    id: 'prod_fi012',
    name: 'Salchichón',
    category: 'fiambres',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🍖',
    description: 'Salchichón con o sin jamón',
    keywords: ['salchichon con jamon']
  },
  {
    id: 'prod_fi021', // NUEVO
    name: 'Salchichón primavera',
    category: 'fiambres',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🍖',
    description: 'Salchichón primavera',
    keywords: ['primavera']
  },
  {
    id: 'prod_fi013',
    name: 'Chorizo español',
    category: 'fiambres',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg', 'unidad'],
    icon: '🌭',
    description: 'Chorizo español curado',
    keywords: ['chorizo colorado']
  },
  {
    id: 'prod_fi022', // NUEVO
    name: 'Cantimpalo',
    category: 'fiambres',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg', 'unidad'],
    icon: '🍖',
    description: 'Chorizo cantimpalo',
    keywords: ['cantimpalo']
  },
  {
    id: 'prod_fi023', // NUEVO
    name: 'Longaniza',
    category: 'fiambres',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'g', 'kg'],
    icon: '🍖',
    description: 'Longaniza curada',
    keywords: ['longaniza calabresa']
  },
  {
    id: 'prod_fi014',
    name: 'Copetín',
    category: 'fiambres',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🍖',
    description: 'Salamín tipo copetín',
    keywords: ['salamin', 'snack']
  },
  {
    id: 'prod_fi015',
    name: 'Paleta',
    category: 'fiambres',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🍖',
    description: 'Paleta cocida feteada',
    keywords: ['paleta de cerdo', 'jamon economico', 'paleta sanguchera']
  },
  {
    id: 'prod_fi016',
    name: 'Mortadela con aceitunas',
    category: 'fiambres',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🍖',
    description: 'Mortadela con aceitunas',
    keywords: ['bocha con aceitunas']
  },
  {
    id: 'prod_fi017',
    name: 'Salame picante',
    category: 'fiambres',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🍖',
    description: 'Salame picante o calabrés',
    keywords: ['spianata', 'calabres']
  },
  {
    id: 'prod_fi018',
    name: 'Jamón natural',
    category: 'fiambres',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🍖',
    description: 'Jamón cocido natural sin conservantes',
    keywords: ['jamon horneado']
  },
  {
    id: 'prod_fi019',
    name: 'Pechuga de pavo',
    category: 'fiambres',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🍖',
    description: 'Pechuga de pavo en fetas',
    keywords: ['pavo']
  },
  {
    id: 'prod_fi020',
    name: 'Matambre arrollado',
    category: 'fiambres',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🍖',
    description: 'Matambre de carne o pollo feteado',
    keywords: ['matambre de carne', 'matambre de pollo', 'matambre casero']
  }
];

// ============================================
// LEGUMBRES (14 productos) ✅ LIMPIO & OPTIMIZADO PARA BUSCADOR
// ============================================
const LEGUMBRES = [
  // LEGUMBRES SECAS (Se suelen comprar en paquetes de 400g/500g o sueltas por gramos en dietéticas)
  {
    id: 'prod_leg001',
    name: 'Lentejas secas',
    category: 'legumbres',
    defaultUnit: 'g', // Suelen ser paquetes de 400/500g
    commonUnits: ['g', 'kg', 'paquete'],
    icon: '🫘',
    description: 'Lentejones o lentejas secas',
    keywords: ['lentejon', 'lenteja', 'lenteja turca']
  },
  {
    id: 'prod_leg002',
    name: 'Garbanzos secos',
    category: 'legumbres',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg', 'paquete'],
    icon: '🫘',
    description: 'Garbanzos secos',
    keywords: ['garbanzo']
  },
  {
    id: 'prod_leg003',
    name: 'Porotos negros',
    category: 'legumbres',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg', 'paquete'],
    icon: '🫘',
    description: 'Porotos negros secos',
    keywords: ['frijoles negros', 'alubias negras', 'poroto negro']
  },
  {
    id: 'prod_leg004',
    name: 'Porotos blancos',
    category: 'legumbres',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg', 'paquete'],
    icon: '🫘',
    description: 'Porotos alubia o pallares',
    keywords: ['alubias', 'pallares', 'poroto blanco', 'poroto alubia']
  },
  {
    id: 'prod_leg005',
    name: 'Porotos colorados',
    category: 'legumbres',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg', 'paquete'],
    icon: '🫘',
    description: 'Porotos colorados',
    keywords: ['frijoles rojos', 'poroto rojo']
  },
  {
    id: 'prod_leg006',
    name: 'Arvejas partidas',
    category: 'legumbres',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg', 'paquete'],
    icon: '🫘',
    description: 'Arvejas partidas secas para sopa o puré',
    keywords: ['guisantes secos', 'arveja seca']
  },
  {
    id: 'prod_leg007',
    name: 'Soja texturizada',
    category: 'legumbres',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg', 'paquete'],
    icon: '🫘',
    description: 'Soja texturizada (fina o gruesa)',
    keywords: ['carne de soja', 'proteina de soja', 'soja texturizada fina']
  },
  {
    id: 'prod_leg008',
    name: 'Porotos de soja',
    category: 'legumbres',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg', 'paquete'],
    icon: '🫘',
    description: 'Porotos de soja secos',
    keywords: ['soja seca']
  },
  {
    id: 'prod_leg009',
    name: 'Habas secas',
    category: 'legumbres',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg', 'paquete'],
    icon: '🫘',
    description: 'Habas secas peladas o con piel',
    keywords: ['haba']
  },

  // LEGUMBRES LISTAS / EN CONSERVA (Súper comunes en las compras semanales)
  {
    id: 'prod_leg011', // NUEVO
    name: 'Arvejas en lata/caja',
    category: 'legumbres',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'lata', 'caja'],
    icon: '🫛',
    description: 'Arvejas listas para consumir',
    keywords: ['lata de arvejas', 'caja de arvejas', 'guisantes en lata']
  },
  {
    id: 'prod_leg012', // NUEVO
    name: 'Lentejas en lata/caja',
    category: 'legumbres',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'lata', 'caja'],
    icon: '🥫',
    description: 'Lentejas remojadas y listas',
    keywords: ['lata de lentejas', 'caja de lentejas']
  },
  {
    id: 'prod_leg013', // NUEVO
    name: 'Garbanzos en lata/caja',
    category: 'legumbres',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'lata', 'caja'],
    icon: '🥫',
    description: 'Garbanzos listos para consumir',
    keywords: ['lata de garbanzos', 'caja de garbanzos']
  },
  {
    id: 'prod_leg014', // NUEVO
    name: 'Porotos en lata/caja',
    category: 'legumbres',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'lata', 'caja'],
    icon: '🥫',
    description: 'Porotos blancos o colorados listos',
    keywords: ['lata de porotos', 'porotos en conserva']
  },
  {
    id: 'prod_leg015', // NUEVO
    name: 'Choclo en lata',
    category: 'legumbres',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'lata'],
    icon: '🌽',
    description: 'Choclo amarillo en grano (cremoso o entero)',
    keywords: ['lata de choclo', 'choclo cremoso', 'choclo en grano', 'maiz en lata']
  }
];


// ============================================
// FRUTAS (36 productos) ✅ LIMPIO & OPTIMIZADO PARA BUSCADOR
// ============================================
const FRUTAS = [
  // POR PIEZA o A GRANEL según corresponda
  {
    id: 'prod_f001',
    name: 'Banana',
    category: 'frutas',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🍌',
    description: 'Banana común o ecuador',
    keywords: ['plátano', 'bananas']
  },
  {
    id: 'prod_f002',
    name: 'Manzana',
    category: 'frutas',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🍎',
    description: 'Manzana (sin especificar)',
    keywords: ['manzanas']
  },
  {
    id: 'prod_f036', // NUEVO (Separado de la verde)
    name: 'Manzana roja',
    category: 'frutas',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🍎',
    description: 'Manzana roja',
    keywords: ['manzana deliciosa']
  },
  {
    id: 'prod_f035', 
    name: 'Manzana verde',
    category: 'frutas',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🍏',
    description: 'Manzana verde Granny Smith',
    keywords: ['manzana acida']
  },
  {
    id: 'prod_f003',
    name: 'Naranja',
    category: 'frutas',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🍊',
    description: 'Naranja para jugo o de ombligo',
    keywords: ['naranja de ombligo', 'naranja de jugo']
  },
  {
    id: 'prod_f004',
    name: 'Mandarina',
    category: 'frutas',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🍊',
    description: 'Mandarina (cualquier variedad)',
    keywords: ['criolla', 'dancy', 'murcott']
  },
  {
    id: 'prod_f005',
    name: 'Limón',
    category: 'frutas',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🍋',
    description: 'Limón común',
    keywords: ['limones']
  },
  {
    id: 'prod_f006',
    name: 'Pera',
    category: 'frutas',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🍐',
    description: 'Pera Williams o Packhams',
    keywords: ['peras']
  },
  {
    id: 'prod_f007',
    name: 'Durazno',
    category: 'frutas',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🍑',
    description: 'Durazno fresco',
    keywords: ['melocotón', 'duraznos']
  },
  {
    id: 'prod_f008',
    name: 'Ciruela',
    category: 'frutas',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🫐', // Dejé este ícono que pusiste, aunque no hay ciruela en emoji, es lo más parecido en color
    description: 'Ciruela fresca (Remolacha o gota de oro)',
    keywords: ['ciruelas']
  },
  
  // A GRANEL (Suelen venderse en bandejitas)
  {
    id: 'prod_f009',
    name: 'Frutilla',
    category: 'frutas',
    defaultUnit: 'kg', // A veces se vende por cajón de kg o bandejita
    commonUnits: ['kg', 'g'],
    icon: '🍓',
    description: 'Frutilla fresca',
    keywords: ['fresa', 'frutillas']
  },
  {
    id: 'prod_f010',
    name: 'Uva',
    category: 'frutas',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🍇',
    description: 'Uva blanca, negra o chinche',
    keywords: ['uvas', 'uva blanca', 'uva negra', 'uva sin semilla']
  },
  
  // POR PIEZA
  {
    id: 'prod_f011',
    name: 'Sandía',
    category: 'frutas',
    defaultUnit: 'unidad', // Más común comprar 1/2 o 1 entera
    commonUnits: ['unidad', 'kg', 'g'],
    icon: '🍉',
    description: 'Sandía entera o en mitades',
    keywords: ['patilla', 'media sandia']
  },
  {
    id: 'prod_f012',
    name: 'Melón',
    category: 'frutas',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'kg', 'g'],
    icon: '🍈',
    description: 'Melón rocío de miel o escrito',
    keywords: ['melon rocio de miel']
  },
  {
    id: 'prod_f013',
    name: 'Ananá',
    category: 'frutas',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'kg', 'g'],
    icon: '🍍',
    description: 'Ananá fresco entero',
    keywords: ['piña', 'anana']
  },
  {
    id: 'prod_f014',
    name: 'Kiwi',
    category: 'frutas',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🥝',
    description: 'Kiwi fresco',
    keywords: ['kiwis']
  },
  {
    id: 'prod_f015',
    name: 'Palta',
    category: 'frutas',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🥑',
    description: 'Palta Hass o chilena',
    keywords: ['aguacate', 'paltas']
  },
  {
    id: 'prod_f016',
    name: 'Pomelo',
    category: 'frutas',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🍊',
    description: 'Pomelo rosado o blanco',
    keywords: ['toronja', 'pomelo rosado', 'pomelo blanco']
  },
  
  // A GRANEL / BANDEJAS
  {
    id: 'prod_f017',
    name: 'Arándanos',
    category: 'frutas',
    defaultUnit: 'g', // Bandejitas de 125g/250g
    commonUnits: ['g', 'kg'],
    icon: '🫐',
    description: 'Arándanos frescos',
    keywords: ['bandeja de arandanos']
  },
  {
    id: 'prod_f018',
    name: 'Frambuesa',
    category: 'frutas',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🍓',
    description: 'Frambuesas frescas',
    keywords: ['frambuesas']
  },
  {
    id: 'prod_f019',
    name: 'Mora',
    category: 'frutas',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🫐',
    description: 'Moras frescas',
    keywords: ['moras']
  },
  {
    id: 'prod_f020',
    name: 'Cereza',
    category: 'frutas',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🍒',
    description: 'Cerezas frescas',
    keywords: ['cerezas']
  },
  
  // POR PIEZA
  {
    id: 'prod_f021',
    name: 'Coco',
    category: 'frutas',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'kg', 'g'],
    icon: '🥥',
    description: 'Coco fresco entero',
    keywords: []
  },
  {
    id: 'prod_f022',
    name: 'Mango',
    category: 'frutas',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🥭',
    description: 'Mango fresco',
    keywords: []
  },
  {
    id: 'prod_f023',
    name: 'Membrillo',
    category: 'frutas',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🍎',
    description: 'Membrillo fresco',
    keywords: []
  },
  {
    id: 'prod_f024',
    name: 'Higo',
    category: 'frutas',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🫐',
    description: 'Higo fresco',
    keywords: ['higos']
  },
  
  // FRUTOS SECOS (Listados en Frutas)
  {
    id: 'prod_f025',
    name: 'Pasas de uva',
    category: 'frutas',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🍇',
    description: 'Pasas de uva (rubias o negras)',
    keywords: ['pasas rubias', 'pasas negras', 'uvas pasas']
  },
  
  // A GRANEL
  {
    id: 'prod_f026',
    name: 'Damasco',
    category: 'frutas',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🍑',
    description: 'Damasco fresco',
    keywords: ['albaricoque', 'damascos']
  },
  {
    id: 'prod_f027',
    name: 'Nectarina',
    category: 'frutas',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🍑',
    description: 'Nectarina',
    keywords: ['nectarinas']
  },
  {
    id: 'prod_f028',
    name: 'Pelón',
    category: 'frutas',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🍑',
    description: 'Pelón (durazno pelado)',
    keywords: ['pelones']
  },
  {
    id: 'prod_f029',
    name: 'Quinoto',
    category: 'frutas',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🍊',
    description: 'Quinoto',
    keywords: ['kumquat', 'quinotos']
  },
  {
    id: 'prod_f030',
    name: 'Lima',
    category: 'frutas',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🍋',
    description: 'Lima',
    keywords: ['limas']
  },
  {
    id: 'prod_f031',
    name: 'Papaya',
    category: 'frutas',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🥭',
    description: 'Papaya',
    keywords: ['mamón']
  },
  {
    id: 'prod_f032',
    name: 'Maracuyá',
    category: 'frutas',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🥭',
    description: 'Maracuyá fresco',
    keywords: ['fruta de la pasión', 'maracuya']
  },
  
  // ENLATADOS / CONSERVAS
  {
    id: 'prod_f033',
    name: 'Durazno enlatado',
    category: 'frutas',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'lata'],
    icon: '🥫',
    description: 'Duraznos en almíbar enlatados (mitades)',
    keywords: ['duraznos en almibar', 'lata de duraznos', 'duraznos en lata']
  },
  {
    id: 'prod_f034',
    name: 'Cóctel de frutas',
    category: 'frutas',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'lata'],
    icon: '🥫',
    description: 'Ensalada de frutas en lata',
    keywords: ['coctel de frutas enlatado', 'ensalada de frutas en lata', 'lata de ensalada de frutas']
  }
];

// ============================================
// BEBIDAS (34 productos) ✅ LIMPIO & OPTIMIZADO PARA BUSCADOR
// ============================================
// ============================================
// BEBIDAS (34 productos) ✅ LIMPIO & OPTIMIZADO PARA BUSCADOR
// ============================================
const BEBIDAS = [
  // AGUAS Y SODAS
  {
    id: 'prod_b001',
    name: 'Agua mineral',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 Botella/Bidón
    commonUnits: ['unidad', 'l', 'ml'],
    icon: '💧',
    description: 'Agua mineral con o sin gas',
    keywords: ['agua con gas', 'agua sin gas', 'botella de agua', 'bidon de agua']
  },
  {
    id: 'prod_b018',
    name: 'Agua saborizada',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 Botella
    commonUnits: ['unidad', 'l', 'ml'],
    icon: '💧',
    description: 'Agua saborizada (manzana, pomelo, etc.)',
    keywords: ['levite', 'aquarius', 'saborizada', 'ser']
  },
  {
    id: 'prod_b031', 
    name: 'Soda (Sifón)',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 El sifón se cuenta por unidad
    commonUnits: ['unidad', 'l'],
    icon: '🫧',
    description: 'Sifón de soda o botella',
    keywords: ['soda', 'sifon', 'agua carbonatada']
  },
  {
    id: 'prod_b026',
    name: 'Agua Tónica',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 Botella
    commonUnits: ['unidad', 'l', 'ml'],
    icon: '🥤',
    description: 'Agua tónica (Paso de los Toros, Schweppes)',
    keywords: ['tonica', 'paso de los toros tonica']
  },

  // GASEOSAS
  {
    id: 'prod_b002',
    name: 'Gaseosa Cola',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 Botella/Lata
    commonUnits: ['unidad', 'l', 'ml'],
    icon: '🥤',
    description: 'Gaseosa sabor cola genérica',
    keywords: ['pepsi', 'manaos', 'doble cola']
  },
  {
    id: 'prod_b021',
    name: 'Coca Cola',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 Botella/Lata
    commonUnits: ['unidad', 'l', 'ml'],
    icon: '🥤',
    description: 'Coca Cola clásica, Zero o Light',
    keywords: ['coca', 'coca zero', 'coca light']
  },
  {
    id: 'prod_b022',
    name: 'Gaseosa Lima-Limón',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 Botella/Lata
    commonUnits: ['unidad', 'l', 'ml'],
    icon: '🥤',
    description: 'Sprite, 7up, etc.',
    keywords: ['sprite', '7up', 'paso de los toros limon']
  },
  {
    id: 'prod_b032', 
    name: 'Gaseosa Naranja',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 Botella/Lata
    commonUnits: ['unidad', 'l', 'ml'],
    icon: '🥤',
    description: 'Fanta, Mirinda, etc.',
    keywords: ['fanta', 'mirinda', 'gaseosa naranja', 'crush']
  },
  {
    id: 'prod_b023',
    name: 'Gaseosa Pomelo',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 Botella/Lata
    commonUnits: ['unidad', 'l', 'ml'],
    icon: '🥤',
    description: 'Paso de los Toros, Quatro',
    keywords: ['paso de los toros pomelo', 'quatro pomelo']
  },

  // JUGOS E ISOTÓNICAS
  {
    id: 'prod_b003',
    name: 'Jugo concentrado',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 Botella
    commonUnits: ['unidad', 'l', 'ml'],
    icon: '🧃',
    description: 'Jugo concentrado para diluir (Mocoretá)',
    keywords: ['mocoreta', 'jugo para diluir', 'caricia']
  },
  {
    id: 'prod_b033', 
    name: 'Jugo en polvo',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 Sobrecito
    commonUnits: ['unidad'],
    icon: '🧃',
    description: 'Sobres de jugo en polvo',
    keywords: ['tang', 'clight', 'jugo en sobre', 'arcor', 'bc']
  },
  {
    id: 'prod_b004',
    name: 'Jugo natural exprimido',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 Botella
    commonUnits: ['unidad', 'l', 'ml'],
    icon: '🧃',
    description: 'Jugo natural de fruta',
    keywords: ['jugo de naranja', 'citric exprimidor']
  },
  {
    id: 'prod_b029',
    name: 'Jugo en caja / Tetra',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 Caja/Tetra
    commonUnits: ['unidad', 'l', 'ml'],
    icon: '🧃',
    description: 'Baggio, Cepita, Ades',
    keywords: ['baggio', 'cepita', 'jugo de manzana', 'tetra de jugo']
  },
  {
    id: 'prod_b027',
    name: 'Bebida deportiva',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 Botella
    commonUnits: ['unidad', 'l', 'ml'],
    icon: '⚡',
    description: 'Gatorade, Powerade',
    keywords: ['gatorade', 'powerade', 'isotonica']
  },
  {
    id: 'prod_b009',
    name: 'Energizante',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 Lata
    commonUnits: ['unidad', 'ml'],
    icon: '⚡',
    description: 'Bebida energizante en lata',
    keywords: ['speed', 'red bull', 'monster', 'rad 60']
  },
  {
    id: 'prod_b028',
    name: 'Té helado',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 Botella
    commonUnits: ['unidad', 'l', 'ml'],
    icon: '🧃',
    description: 'Té frío listo para tomar',
    keywords: ['ice tea', 'lipton']
  },

  // INFUSIONES (Secos)
  {
    id: 'prod_b010',
    name: 'Café',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 Frasco o paquete
    commonUnits: ['unidad', 'g', 'kg'],
    icon: '☕',
    description: 'Café molido, en grano o instantáneo',
    keywords: ['cafe dolca', 'nescafe', 'cafe molido', 'cafe torrado', 'cabrales', 'la virginia']
  },
  {
    id: 'prod_b011',
    name: 'Té',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 Caja de saquitos
    commonUnits: ['unidad'],
    icon: '🍵',
    description: 'Té en saquitos (común o sabores)',
    keywords: ['te verde', 'caja de te', 'green hills', 'taragui', 'la virginia']
  },
  {
    id: 'prod_b012',
    name: 'Yerba mate',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 Paquete
    commonUnits: ['unidad', 'kg', 'g'],
    icon: '🧉',
    description: 'Yerba mate (Paquete)',
    keywords: ['yerba', 'playadito', 'taragui', 'cbsé', 'rosamonte', 'amanda']
  },
  {
    id: 'prod_b013',
    name: 'Cacao en polvo',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 Caja o bolsa
    commonUnits: ['unidad', 'g', 'kg'],
    icon: '🍫',
    description: 'Cacao para preparar leche',
    keywords: ['nesquik', 'chocolatada', 'toddy', 'cacao dulce']
  },

  // LECHES
  {
    id: 'prod_b014',
    name: 'Leche entera',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 Sachet o caja
    commonUnits: ['unidad', 'l', 'ml'],
    icon: '🥛',
    description: 'Leche entera (sachet o caja)',
    keywords: ['sachet de leche', 'leche larga vida', 'leche roja', 'la serenisima']
  },
  {
    id: 'prod_b015',
    name: 'Leche descremada',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 Sachet o caja
    commonUnits: ['unidad', 'l', 'ml'],
    icon: '🥛',
    description: 'Leche descremada / light',
    keywords: ['leche light', 'sachet verde', 'leche descremada']
  },
  {
    id: 'prod_b016',
    name: 'Leche de almendras',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 Caja
    commonUnits: ['unidad', 'l', 'ml'],
    icon: '🥛',
    description: 'Leche vegetal de almendra',
    keywords: ['leche vegetal', 'silk', 'vrink']
  },
  {
    id: 'prod_b017',
    name: 'Leche de soja',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 Caja
    commonUnits: ['unidad', 'l', 'ml'],
    icon: '🥛',
    description: 'Leche de soja',
    keywords: ['ades']
  },

  // ALCOHOL
  {
    id: 'prod_b005',
    name: 'Cerveza',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 Botella (litro) o lata
    commonUnits: ['unidad', 'l', 'ml'],
    icon: '🍺',
    description: 'Botella o lata de cerveza',
    keywords: ['birra', 'lata de cerveza', 'quilmes', 'brahma', 'stella', 'patagonia']
  },
  {
    id: 'prod_b025',
    name: 'Cerveza sin alcohol',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 Botella o lata
    commonUnits: ['unidad', 'l', 'ml'],
    icon: '🍺',
    description: 'Cerveza 0% alcohol',
    keywords: []
  },
  {
    id: 'prod_b006',
    name: 'Vino tinto',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 Botella o caja
    commonUnits: ['unidad', 'l', 'ml'],
    icon: '🍷',
    description: 'Botella de vino tinto (Malbec, Cabernet)',
    keywords: ['malbec', 'botella de vino', 'vino en caja', 'termidor']
  },
  {
    id: 'prod_b007',
    name: 'Vino blanco',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 Botella
    commonUnits: ['unidad', 'l', 'ml'],
    icon: '🍷',
    description: 'Botella de vino blanco dulce o seco',
    keywords: ['blanco dulce', 'chardonnay', 'sauvignon blanc']
  },
  {
    id: 'prod_b024',
    name: 'Vino rosado',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 Botella
    commonUnits: ['unidad', 'l', 'ml'],
    icon: '🍷',
    description: 'Botella de vino rosado',
    keywords: ['rosado']
  },
  {
    id: 'prod_b008',
    name: 'Fernet',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 Botella
    commonUnits: ['unidad', 'l', 'ml'],
    icon: '🥃',
    description: 'Botella de Fernet',
    keywords: ['fernet branca', 'branca', '1882']
  },
  {
    id: 'prod_b030',
    name: 'Amargo serrano / Terma',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 Botella
    commonUnits: ['unidad', 'l', 'ml'],
    icon: '🥃',
    description: 'Amargo serrano o de hierbas',
    keywords: ['terma', 'cuyano']
  },
  {
    id: 'prod_b034', 
    name: 'Campari / Aperitivos',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 Botella
    commonUnits: ['unidad', 'l', 'ml'],
    icon: '🍹',
    description: 'Botella de aperitivo (Gancia, Aperol, etc.)',
    keywords: ['campari', 'gancia', 'aperol', 'cynar', 'aperitivo']
  },
  {
    id: 'prod_b019',
    name: 'Sidra',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 Botella
    commonUnits: ['unidad', 'l'],
    icon: '🍾',
    description: 'Botella de sidra',
    keywords: ['real', 'victoria']
  },
  {
    id: 'prod_b020',
    name: 'Champagne',
    category: 'bebidas',
    defaultUnit: 'unidad', // 👈 Botella
    commonUnits: ['unidad', 'l'],
    icon: '🍾',
    description: 'Botella de Champagne o espumante',
    keywords: ['espumante', 'champaña', 'chandon', 'mumm']
  }
];

// ============================================
// LÁCTEOS (32 productos) ✅ LIMPIO & OPTIMIZADO PARA BUSCADOR
// ============================================
const LACTEOS = [
  // LECHES LÍQUIDAS
  {
    id: 'prod_l001',
    name: 'Leche entera',
    category: 'lácteos',
    defaultUnit: 'l',
    commonUnits: ['l', 'ml', 'unidad'],
    icon: '🥛',
    description: 'Leche entera en sachet o botella',
    keywords: ['sachet de leche', 'leche larga vida', 'leche roja']
  },
  {
    id: 'prod_l002',
    name: 'Leche descremada',
    category: 'lácteos',
    defaultUnit: 'l',
    commonUnits: ['l', 'ml', 'unidad'],
    icon: '🥛',
    description: 'Leche descremada o parcialmente descremada',
    keywords: ['leche light', 'sachet verde']
  },
  {
    id: 'prod_l031', // NUEVO y necesario
    name: 'Leche chocolatada',
    category: 'lácteos',
    defaultUnit: 'l',
    commonUnits: ['l', 'ml', 'unidad'],
    icon: '🧃',
    description: 'Leche chocolatada lista para tomar',
    keywords: ['cindor', 'chocolatada']
  },
  {
    id: 'prod_l030',
    name: 'Leche cultivada',
    category: 'lácteos',
    defaultUnit: 'l',
    commonUnits: ['l', 'ml', 'unidad'],
    icon: '🥛',
    description: 'Leche cultivada o probiótica',
    keywords: ['actimel', 'yakult']
  },
  
  // LECHES SÓLIDAS/SEMI
  {
    id: 'prod_l003',
    name: 'Leche en polvo',
    category: 'lácteos',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg', 'unidad'],
    icon: '🥛',
    description: 'Leche en polvo entera o descremada',
    keywords: ['nido', 'purisima']
  },
  {
    id: 'prod_l018',
    name: 'Leche condensada',
    category: 'lácteos',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'lata', 'g'],
    icon: '🥛',
    description: 'Leche condensada',
    keywords: ['lata de leche condensada', 'nestle']
  },

  // YOGURES Y POSTRES
  {
    id: 'prod_l004',
    name: 'Yogur natural',
    category: 'lácteos',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'g'],
    icon: '🥛',
    description: 'Yogur natural sin sabor (pote)',
    keywords: ['yogur neutro']
  },
  {
    id: 'prod_l005',
    name: 'Yogur firme / batido',
    category: 'lácteos',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'g'],
    icon: '🥛',
    description: 'Yogur en pote con sabor o cereales',
    keywords: ['yogur en pote', 'yogur de frutilla', 'yogur de vainilla', 'yoghurt']
  },
  {
    id: 'prod_l006',
    name: 'Yogur bebible',
    category: 'lácteos',
    defaultUnit: 'l',
    commonUnits: ['l', 'ml', 'unidad'],
    icon: '🥛',
    description: 'Yogur bebible en sachet o botella',
    keywords: ['sachet de yogur', 'yoghurt bebible']
  },
  {
    id: 'prod_l019',
    name: 'Flan',
    category: 'lácteos',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '🍮',
    description: 'Flan preparado (pote)',
    keywords: ['flancito']
  },
  {
    id: 'prod_l020',
    name: 'Postre lácteo',
    category: 'lácteos',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '🍮',
    description: 'Postrecito tipo Ser, Danonino, Serenito',
    keywords: ['serenito', 'danonino', 'postrecito', 'shimmy']
  },

  // QUESOS FRESCOS Y BLANDOS
  {
    id: 'prod_l032', // NUEVO: ¡El REY!
    name: 'Queso cremoso',
    category: 'lácteos',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🧀',
    description: 'Queso cremoso, mantecoso o fresco',
    keywords: ['cremoso', 'mantecoso', 'fresco', 'queso para pizza']
  },
  {
    id: 'prod_l010',
    name: 'Queso mozzarella',
    category: 'lácteos',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🧀',
    description: 'Mozzarella para pizza',
    keywords: ['muzza', 'musarela', 'queso de pizza']
  },
  {
    id: 'prod_l027',
    name: 'Queso cuartirolo',
    category: 'lácteos',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🧀',
    description: 'Queso cuartirolo',
    keywords: []
  },
  {
    id: 'prod_l011',
    name: 'Queso por salut',
    category: 'lácteos',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g'],
    icon: '🧀',
    description: 'Queso por salut común o light',
    keywords: ['port salut', 'queso light', 'queso magro']
  },

  // QUESOS DE FIAMBRERÍA (Default g)
  {
    id: 'prod_l009',
    name: 'Queso en barra',
    category: 'lácteos',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🧀',
    description: 'Queso de máquina feteado (Tybo, Danbo)',
    keywords: ['queso de maquina', 'queso feteado', 'tybo', 'danbo']
  },
  {
    id: 'prod_l026',
    name: 'Queso pategrás',
    category: 'lácteos',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🧀',
    description: 'Queso pategrás argentino (Mar del Plata)',
    keywords: ['queso mar del plata', 'queso de cascara colorada', 'pategras']
  },
  {
    id: 'prod_l012',
    name: 'Queso azul',
    category: 'lácteos',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🧀',
    description: 'Queso azul o roquefort',
    keywords: ['roquefort']
  },
  {
    id: 'prod_l023',
    name: 'Queso provolone',
    category: 'lácteos',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🧀',
    description: 'Provolone o provoleta',
    keywords: ['provoleta']
  },

  // QUESOS UNTABLES Y RICOTA
  {
    id: 'prod_l021',
    name: 'Queso untable',
    category: 'lácteos',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'g', 'kg'],
    icon: '🧀',
    description: 'Queso crema para untar (Pote)',
    keywords: ['casancrem', 'mendicrim', 'finlandia', 'queso blanco']
  },
  {
    id: 'prod_l007',
    name: 'Queso crema',
    category: 'lácteos',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'g', 'kg'],
    icon: '🧀',
    description: 'Tipo Philadelphia',
    keywords: ['cream cheese', 'philadelphia']
  },
  {
    id: 'prod_l017',
    name: 'Ricota',
    category: 'lácteos',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg', 'unidad'],
    icon: '🧀',
    description: 'Ricota magra o entera',
    keywords: ['requeson']
  },
  {
    id: 'prod_l022',
    name: 'Queso de cabra',
    category: 'lácteos',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🧀',
    description: 'Queso de cabra',
    keywords: []
  },

  // QUESOS DUROS / RALLADOS
  {
    id: 'prod_l008',
    name: 'Queso rallado',
    category: 'lácteos',
    defaultUnit: 'unidad', // El sobrecito
    commonUnits: ['unidad', 'g', 'kg'],
    icon: '🧀',
    description: 'Queso rallado en sobre',
    keywords: ['sobre de queso', 'quesito rallado']
  },
  {
    id: 'prod_l025',
    name: 'Queso para rallar',
    category: 'lácteos',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🧀',
    description: 'Horma o trozo duro para rallar en casa',
    keywords: ['queso duro']
  },
  {
    id: 'prod_l024',
    name: 'Queso sardo',
    category: 'lácteos',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🧀',
    description: 'Queso sardo fresco o seco',
    keywords: ['sardo']
  },
  {
    id: 'prod_l028',
    name: 'Queso reggianito',
    category: 'lácteos',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg'],
    icon: '🧀',
    description: 'Queso reggianito',
    keywords: ['reggianito']
  },

  // MANTECA, CREMA Y DDL
  {
    id: 'prod_l013',
    name: 'Manteca',
    category: 'lácteos',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg', 'unidad'],
    icon: '🧈',
    description: 'Manteca en pan (100g, 200g)',
    keywords: ['mantequilla', 'pan de manteca']
  },
  {
    id: 'prod_l014',
    name: 'Margarina',
    category: 'lácteos',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg', 'unidad'],
    icon: '🧈',
    description: 'Margarina vegetal',
    keywords: ['dánica']
  },
  {
    id: 'prod_l015',
    name: 'Crema de leche',
    category: 'lácteos',
    defaultUnit: 'ml', // Pote chico de 200ml
    commonUnits: ['ml', 'l', 'unidad'],
    icon: '🥛',
    description: 'Crema para cocinar o batir',
    keywords: ['crema para batir', 'pote de crema', 'crema doble']
  },
  {
    id: 'prod_l029',
    name: 'Crema chantilly',
    category: 'lácteos',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'ml'],
    icon: '🥛',
    description: 'Crema chantilly en aerosol o lista',
    keywords: ['crema en aerosol']
  },
  {
    id: 'prod_l016',
    name: 'Dulce de leche',
    category: 'lácteos',
    defaultUnit: 'g', // Pote de 400g
    commonUnits: ['g', 'kg', 'unidad'],
    icon: '🍯',
    description: 'Dulce de leche repostero o colonial',
    keywords: ['ddl', 'repostero', 'colonial', 'manjar']
  }
];

// ============================================
// HUEVOS (4 productos) ✅ LIMPIO & OPTIMIZADO PARA BUSCADOR
// ============================================
const HUEVOS = [
  {
    id: 'prod_hu001',
    name: 'Huevos',
    category: 'huevos',
    defaultUnit: 'unidad', // Opcional: Podés usar 'docena' o 'maple' en la lista
    commonUnits: ['unidad', 'docena', 'maple'],
    icon: '🥚',
    description: 'Huevos blancos de gallina',
    keywords: ['maple de huevos', 'docena de huevos', 'huevo blanco', 'huevos comunes']
  },
  {
    id: 'prod_hu002', // NUEVO
    name: 'Huevos colorados',
    category: 'huevos',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'docena', 'maple'],
    icon: '🥚', // Mismo ícono, no hay huevo marrón en emoji
    description: 'Huevos colorados / rubios',
    keywords: ['huevo rubio', 'huevo castaño', 'huevo marron']
  },
  {
    id: 'prod_hu003', // NUEVO
    name: 'Huevos de campo / pastoriles',
    category: 'huevos',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'docena', 'maple'],
    icon: '🥚',
    description: 'Huevos orgánicos o de gallinas libres',
    keywords: ['huevo organico', 'gallinas libres', 'huevo de granja']
  },
  {
    id: 'prod_hu004', // NUEVO
    name: 'Huevos de codorniz',
    category: 'huevos',
    defaultUnit: 'unidad', // Suelen venir en cajitas de 12 o 24
    commonUnits: ['unidad', 'caja'],
    icon: '🥚',
    description: 'Para picadas o ensaladas',
    keywords: ['codorniz', 'huevitos']
  }
];

// ============================================
// LIMPIEZA DEL HOGAR (35 productos) ✅ LIMPIO & OPTIMIZADO PARA BUSCADOR
// ============================================
const LIMPIEZA_HOGAR = [
  // LÍQUIDOS Y CREMAS
  {
    id: 'prod_lh001',
    name: 'Detergente',
    category: 'limpieza del hogar',
    defaultUnit: 'unidad', // Se compran botellas
    commonUnits: ['unidad', 'l', 'ml'],
    icon: '🧴',
    description: 'Detergente para vajilla',
    keywords: ['magistral', 'ala', 'zorro', 'detergente lavavajilla']
  },
  {
    id: 'prod_lh002',
    name: 'Lavandina',
    category: 'limpieza del hogar',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'l', 'ml'],
    icon: '🧴',
    description: 'Lavandina o cloro (botella/bidón)',
    keywords: ['cloro', 'lejía', 'ayudin', 'lavandina en gel']
  },
  {
    id: 'prod_lh003',
    name: 'Limpiador en crema / multiuso',
    category: 'limpieza del hogar',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'ml', 'l'],
    icon: '🧴',
    description: 'Limpiador multiuso o en crema',
    keywords: ['cif', 'crema limpiadora', 'cif crema']
  },
  {
    id: 'prod_lh031', // NUEVO - Súper específico y usado
    name: 'Antigrasa',
    category: 'limpieza del hogar',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'ml'],
    icon: '🧴',
    description: 'Limpiador antigrasa gatillo',
    keywords: ['mr musculo', 'cif antigrasa', 'desengrasante']
  },
  {
    id: 'prod_lh004',
    name: 'Limpiador de piso',
    category: 'limpieza del hogar',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'l', 'ml'],
    icon: '🧴',
    description: 'Desodorante líquido para pisos',
    keywords: ['poett', 'procenex', 'glade', 'lysoform pisos']
  },
  {
    id: 'prod_lh005',
    name: 'Limpia vidrios',
    category: 'limpieza del hogar',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'ml', 'l'],
    icon: '🧴',
    description: 'Limpia vidrios (gatillo o repuesto)',
    keywords: ['mr musculo vidrios', 'limpia cristales']
  },
  {
    id: 'prod_lh006',
    name: 'Desinfectante en aerosol',
    category: 'limpieza del hogar',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'ml'],
    icon: '🧴',
    description: 'Desinfectante para ambientes y superficies',
    keywords: ['lysoform', 'desinfectante aerosol']
  },

  // ROPA (LAVADO)
  {
    id: 'prod_lh007',
    name: 'Jabón en polvo',
    category: 'limpieza del hogar',
    defaultUnit: 'unidad', // Paquete o bolsa
    commonUnits: ['unidad', 'kg', 'g'],
    icon: '📦',
    description: 'Jabón en polvo para ropa',
    keywords: ['skip', 'ala', 'ariel', 'jabon ropa', 'polvo para lavar']
  },
  {
    id: 'prod_lh008',
    name: 'Jabón líquido para ropa',
    category: 'limpieza del hogar',
    defaultUnit: 'unidad', // Botella o doypack
    commonUnits: ['unidad', 'l', 'ml'],
    icon: '🧴',
    description: 'Jabón líquido o cápsulas',
    keywords: ['ariel liquido', 'skip liquido', 'ala liquido', 'jabon liquido']
  },
  {
    id: 'prod_lh009',
    name: 'Suavizante',
    category: 'limpieza del hogar',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'l', 'ml'],
    icon: '🧴',
    description: 'Suavizante de ropa',
    keywords: ['vivere', 'comfort', 'suavizante']
  },
  {
    id: 'prod_lh010',
    name: 'Quitamanchas',
    category: 'limpieza del hogar',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'ml', 'l'],
    icon: '🧴',
    description: 'Quitamanchas líquido o polvo',
    keywords: ['trento', 'ayudin ropa', 'vanish']
  },
  {
    id: 'prod_lh032', // NUEVO
    name: 'Jabón en pan / blanco',
    category: 'limpieza del hogar',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'g'],
    icon: '🧼',
    description: 'Jabón blanco para lavar a mano',
    keywords: ['jabon blanco', 'jabon de lavar', 'pan de jabon']
  },

  // UTENSILIOS Y PAPELERÍA
  {
    id: 'prod_lh011',
    name: 'Esponja',
    category: 'limpieza del hogar',
    defaultUnit: 'unidad', // O paquete
    commonUnits: ['unidad'],
    icon: '🧽',
    description: 'Esponja para vajilla',
    keywords: ['esponja mortimer', 'esponjita']
  },
  {
    id: 'prod_lh012',
    name: 'Esponja de acero',
    category: 'limpieza del hogar',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '🧽',
    description: 'Esponja de lana de acero',
    keywords: ['virulana', 'esponja de metal']
  },
  {
    id: 'prod_lh030',
    name: 'Paño de microfibra / amarillo',
    category: 'limpieza del hogar',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '🧻',
    description: 'Paño de limpieza o ballerina',
    keywords: ['ballerina', 'paño amarillo', 'rejilla']
  },
  {
    id: 'prod_lh013',
    name: 'Trapo de piso',
    category: 'limpieza del hogar',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '🧹',
    description: 'Trapo de piso blanco o gris',
    keywords: ['trapo de piso']
  },
  {
    id: 'prod_lh014',
    name: 'Repasador',
    category: 'limpieza del hogar',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '🧻',
    description: 'Repasador de tela para cocina',
    keywords: ['repasadores']
  },
  {
    id: 'prod_lh015',
    name: 'Papel de cocina',
    category: 'limpieza del hogar',
    defaultUnit: 'unidad', // Paquete de rollos
    commonUnits: ['unidad', 'rollo'],
    icon: '📄',
    description: 'Rollos de papel absorbente',
    keywords: ['rollo de cocina', 'papel absorbente', 'sussex', 'elegante']
  },
  {
    id: 'prod_lh016',
    name: 'Servilletas',
    category: 'limpieza del hogar',
    defaultUnit: 'unidad', // Paquete
    commonUnits: ['unidad'],
    icon: '📄',
    description: 'Servilletas de papel',
    keywords: ['servilletas de papel']
  },
  {
    id: 'prod_lh033', // NUEVO (A veces va en higiene, a veces acá)
    name: 'Papel higiénico',
    category: 'limpieza del hogar', // o 'higiene personal' según tu preferencia, pero suele comprarse con el rollo de cocina
    defaultUnit: 'unidad', // Paquete
    commonUnits: ['unidad', 'rollo'],
    icon: '🧻',
    description: 'Papel higiénico en paquete',
    keywords: ['ph', 'higienico', 'papel de baño']
  },
  {
    id: 'prod_lh017',
    name: 'Bolsas de residuos',
    category: 'limpieza del hogar',
    defaultUnit: 'unidad', // Paquete de bolsas
    commonUnits: ['unidad'],
    icon: '🗑️',
    description: 'Bolsas de basura',
    keywords: ['bolsas de consorcio', 'bolsitas de basura']
  },
  {
    id: 'prod_lh018',
    name: 'Guantes de limpieza',
    category: 'limpieza del hogar',
    defaultUnit: 'unidad', // Par
    commonUnits: ['unidad', 'par'],
    icon: '🧤',
    description: 'Guantes de goma',
    keywords: ['guantes de goma', 'guantes amarillos']
  },
  
  // HERRAMIENTAS
  {
    id: 'prod_lh019',
    name: 'Escoba / Escobillón',
    category: 'limpieza del hogar',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '🧹',
    description: 'Escoba o escobillón',
    keywords: ['escobillon']
  },
  {
    id: 'prod_lh020',
    name: 'Pala para basura',
    category: 'limpieza del hogar',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '🧹',
    description: 'Pala de limpieza',
    keywords: ['pala']
  },
  {
    id: 'prod_lh021',
    name: 'Secador de piso',
    category: 'limpieza del hogar',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '🧹',
    description: 'Secador de goma',
    keywords: ['escurridor', 'secador']
  },

  // OTROS QUÍMICOS / AMBIENTES
  {
    id: 'prod_lh022',
    name: 'Desodorante de ambiente',
    category: 'limpieza del hogar',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '🌸',
    description: 'Aerosol o repuesto para ambientes',
    keywords: ['glade', 'aerosol ambiente', 'poett aerosol']
  },
  {
    id: 'prod_lh034', // NUEVO
    name: 'Pastilla para inodoro',
    category: 'limpieza del hogar',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '🚽',
    description: 'Canastita o pastilla desodorante',
    keywords: ['canastita inodoro', 'pastilla inodoro', 'glade inodoro']
  },
  {
    id: 'prod_lh023',
    name: 'Destapa cañerías',
    category: 'limpieza del hogar',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'l', 'ml'],
    icon: '🧴',
    description: 'Destapa cañerías líquido o en escamas',
    keywords: ['plomero liquido']
  },
  {
    id: 'prod_lh024',
    name: 'Alcohol',
    category: 'limpieza del hogar',
    defaultUnit: 'unidad', // Botella
    commonUnits: ['unidad', 'l', 'ml'],
    icon: '🧴',
    description: 'Alcohol etílico, de quemar o en gel',
    keywords: ['alcohol etilico', 'alcohol en gel']
  },
  {
    id: 'prod_lh025',
    name: 'Limpiador de baño',
    category: 'limpieza del hogar',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'ml', 'l'],
    icon: '🧴',
    description: 'Específico para baño (hongos, sarro)',
    keywords: ['cif baño', 'mr musculo baño', 'anti sarro']
  },
  {
    id: 'prod_lh026',
    name: 'Lustramuebles',
    category: 'limpieza del hogar',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'ml', 'l'],
    icon: '🧴',
    description: 'Aerosol o líquido para maderas',
    keywords: ['blem', 'cericol']
  },
  {
    id: 'prod_lh027',
    name: 'Cera para pisos',
    category: 'limpieza del hogar',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'l', 'ml'],
    icon: '🧴',
    description: 'Cera líquida',
    keywords: ['cera suiza', 'gloCot']
  },
  {
    id: 'prod_lh028',
    name: 'Limpia metales',
    category: 'limpieza del hogar',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'ml'],
    icon: '🧴',
    description: 'Para acero inoxidable o bronce',
    keywords: ['brasso', 'cif acero']
  },
  {
    id: 'prod_lh029',
    name: 'Insecticida', // Lo cambié de Nafta para limpiar a Insecticida (más común en supermercado)
    category: 'limpieza del hogar',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'ml'],
    icon: '🦟',
    description: 'Mata moscas, mosquitos o cucarachas',
    keywords: ['raid', 'fuyi', 'mata moscas', 'mata cucarachas']
  }
];


// ============================================
// HIGIENE PERSONAL (30 productos) ✅ LIMPIO & OPTIMIZADO PARA BUSCADOR
// ============================================
const HIGIENE_PERSONAL = [
  // CUIDADO DEL CABELLO Y CUERPO
  {
    id: 'prod_hp001',
    name: 'Shampoo',
    category: 'higiene personal',
    defaultUnit: 'unidad', // Botella
    commonUnits: ['unidad', 'ml', 'l'],
    icon: '🧴',
    description: 'Shampoo para el cabello',
    keywords: ['champu', 'pantene', 'plusbelle', 'sedal', 'head and shoulders']
  },
  {
    id: 'prod_hp002',
    name: 'Acondicionador',
    category: 'higiene personal',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'ml', 'l'],
    icon: '🧴',
    description: 'Acondicionador para cabello',
    keywords: ['crema de enjuague', 'enjuague']
  },
  {
    id: 'prod_hp003',
    name: 'Jabón de tocador',
    category: 'higiene personal',
    defaultUnit: 'unidad', // Paquete o pastilla
    commonUnits: ['unidad'],
    icon: '🧼',
    description: 'Jabón en pastilla para el cuerpo',
    keywords: ['jabon de cuerpo', 'dove', 'rexona', 'lux']
  },
  {
    id: 'prod_hp004',
    name: 'Jabón líquido',
    category: 'higiene personal',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'ml', 'l'],
    icon: '🧴',
    description: 'Jabón líquido para manos o cuerpo',
    keywords: ['jabon de manos', 'espuma']
  },
  {
    id: 'prod_hp005',
    name: 'Gel de baño',
    category: 'higiene personal',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'ml', 'l'],
    icon: '🧴',
    description: 'Gel de ducha',
    keywords: ['gel de ducha', 'body wash']
  },
  {
    id: 'prod_hp010',
    name: 'Desodorante',
    category: 'higiene personal',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '🧴',
    description: 'Aerosol, roll-on o barra',
    keywords: ['rexona', 'axe', 'antitranspirante', 'desodorante a bolilla']
  },

  // CUIDADO BUCAL
  {
    id: 'prod_hp006',
    name: 'Pasta dental',
    category: 'higiene personal',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '🦷',
    description: 'Pasta de dientes',
    keywords: ['colgate', 'sensodyne', 'dentifrico', 'pasta de dientes']
  },
  {
    id: 'prod_hp007',
    name: 'Cepillo de dientes',
    category: 'higiene personal',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '🪥',
    description: 'Cepillo de dientes',
    keywords: []
  },
  {
    id: 'prod_hp008',
    name: 'Enjuague bucal',
    category: 'higiene personal',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'ml', 'l'],
    icon: '🧴',
    description: 'Enjuague bucal',
    keywords: ['listerine', 'plax']
  },
  {
    id: 'prod_hp009',
    name: 'Hilo dental',
    category: 'higiene personal',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '🦷',
    description: 'Hilo o cinta dental',
    keywords: []
  },

  // HIGIENE FEMENINA (¡Súper necesario agregarlo!)
  {
    id: 'prod_hp026', // NUEVO
    name: 'Toallitas femeninas',
    category: 'higiene personal',
    defaultUnit: 'unidad', // Paquete
    commonUnits: ['unidad'],
    icon: '🩸', // O algún ícono de cuidado/salud
    description: 'Toallitas higiénicas',
    keywords: ['siempre libre', 'nosotras', 'toallas femeninas', 'protectores']
  },
  {
    id: 'prod_hp027', // NUEVO
    name: 'Protectores diarios',
    category: 'higiene personal',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '🩸',
    description: 'Protectores diarios',
    keywords: ['carefree', 'protectores']
  },
  {
    id: 'prod_hp028', // NUEVO
    name: 'Tampones',
    category: 'higiene personal',
    defaultUnit: 'unidad', // Caja
    commonUnits: ['unidad'],
    icon: '🩸',
    description: 'Tampones',
    keywords: ['ob', 'tampax']
  },

  // PAPELERÍA Y ALGODÓN
  {
    id: 'prod_hp011',
    name: 'Papel higiénico',
    category: 'higiene personal',
    defaultUnit: 'unidad', // Paquete
    commonUnits: ['unidad', 'rollo'],
    icon: '🧻',
    description: 'Papel higiénico',
    keywords: ['ph', 'higienico', 'papel de baño']
  },
  {
    id: 'prod_hp012',
    name: 'Toallitas húmedas',
    category: 'higiene personal',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '🧻',
    description: 'Toallitas húmedas (bebé o desmaquillantes)',
    keywords: ['toallas humedas', 'toallitas de bebe', 'desmaquillantes']
  },
  {
    id: 'prod_hp013',
    name: 'Pañuelos descartables',
    category: 'higiene personal',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '📄',
    description: 'Pañuelos descartables de papel',
    keywords: ['elite', 'carilinas']
  },
  {
    id: 'prod_hp014',
    name: 'Algodón',
    category: 'higiene personal',
    defaultUnit: 'unidad', // Paquete
    commonUnits: ['unidad', 'g'],
    icon: '☁️',
    description: 'Algodón en bolitas o discos',
    keywords: ['estrella', 'discos desmaquillantes', 'algodon en rollo']
  },
  {
    id: 'prod_hp015',
    name: 'Hisopos',
    category: 'higiene personal',
    defaultUnit: 'unidad', // Cajita
    commonUnits: ['unidad'],
    icon: '🧏',
    description: 'Hisopos de algodón',
    keywords: ['cotonetes', 'q-tips']
  },

  // CREMAS Y CUIDADO DE PIEL
  {
    id: 'prod_hp016',
    name: 'Crema de manos',
    category: 'higiene personal',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'ml'],
    icon: '🧴',
    description: 'Crema hidratante para manos',
    keywords: []
  },
  {
    id: 'prod_hp017',
    name: 'Crema corporal',
    category: 'higiene personal',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'ml'],
    icon: '🧴',
    description: 'Crema hidratante corporal',
    keywords: ['nivea', 'crema humectante', 'body lotion']
  },
  {
    id: 'prod_hp018',
    name: 'Protector solar',
    category: 'higiene personal',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'ml'],
    icon: '☀️',
    description: 'Protector solar (FPS)',
    keywords: ['dermaglos', 'bloqueador', 'bronceador']
  },
  {
    id: 'prod_hp029', // NUEVO - Imprescindible en Argentina
    name: 'Repelente de mosquitos',
    category: 'higiene personal',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'ml'],
    icon: '🦟',
    description: 'Aerosol o crema',
    keywords: ['off', 'repelente', 'fuyi', 'mata mosquitos']
  },
  {
    id: 'prod_hp024',
    name: 'Talco',
    category: 'higiene personal',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'g'],
    icon: '🧴',
    description: 'Talco para el cuerpo o pies',
    keywords: ['talco para pies', 'eficient']
  },

  // AFEITADO Y ACCESORIOS
  {
    id: 'prod_hp019',
    name: 'Máquina de afeitar',
    category: 'higiene personal',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '🪒',
    description: 'Máquina descartable o repuestos',
    keywords: ['gillette', 'maquinita', 'prestobarba']
  },
  {
    id: 'prod_hp020',
    name: 'Espuma de afeitar',
    category: 'higiene personal',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'ml'],
    icon: '🧴',
    description: 'Espuma o gel de afeitar',
    keywords: ['gel de afeitar']
  },
  {
    id: 'prod_hp025',
    name: 'After shave',
    category: 'higiene personal',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'ml'],
    icon: '🧴',
    description: 'Loción para después de afeitar',
    keywords: []
  },
  {
    id: 'prod_hp021',
    name: 'Cepillo para el pelo',
    category: 'higiene personal',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '🪮',
    description: 'Cepillo para el cabello',
    keywords: []
  },
  {
    id: 'prod_hp022',
    name: 'Peine',
    category: 'higiene personal',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '🪮',
    description: 'Peine',
    keywords: []
  },
  {
    id: 'prod_hp023',
    name: 'Perfume / Colonia',
    category: 'higiene personal',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'ml'],
    icon: '🧴',
    description: 'Perfume, colonia o body splash',
    keywords: ['body splash']
  }
];

// ============================================
// MASCOTAS (22 productos) ✅ LIMPIO & OPTIMIZADO PARA BUSCADOR
// ============================================
const MASCOTAS = [
  // ALIMENTO BALANCEADO
  {
    id: 'prod_m001',
    name: 'Alimento para perros',
    category: 'mascotas',
    defaultUnit: 'unidad', // Bolsa
    commonUnits: ['unidad', 'kg'],
    icon: '🐕',
    description: 'Bolsa de alimento balanceado',
    keywords: ['dog chow', 'pedigree', 'eukanuba', 'royal canin', 'comida para perros', 'balanceado perro']
  },
  {
    id: 'prod_m002',
    name: 'Alimento para gatos',
    category: 'mascotas',
    defaultUnit: 'unidad', // Bolsa
    commonUnits: ['unidad', 'kg'],
    icon: '🐈',
    description: 'Bolsa de alimento balanceado',
    keywords: ['cat chow', 'whiskas', 'purina', 'comida para gatos', 'balanceado gato']
  },

  // COMIDA HÚMEDA / SNACKS
  {
    id: 'prod_m006',
    name: 'Latas para perros',
    category: 'mascotas',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '🥫',
    description: 'Comida húmeda enlatada',
    keywords: ['lata perro', 'paté perro']
  },
  {
    id: 'prod_m007',
    name: 'Latas para gatos',
    category: 'mascotas',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '🥫',
    description: 'Comida húmeda enlatada',
    keywords: ['lata gato', 'paté gato']
  },
  {
    id: 'prod_m021', // NUEVO: Súper común en los súper
    name: 'Sobrecitos de comida húmeda',
    category: 'mascotas',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '🍲',
    description: 'Pouch / Sobrecitos para perros o gatos',
    keywords: ['pouch', 'sobrecito perro', 'sobrecito gato', 'comida humeda', 'whiskas sobrecito']
  },
  {
    id: 'prod_m003',
    name: 'Snacks para perros',
    category: 'mascotas',
    defaultUnit: 'unidad', // Paquetito
    commonUnits: ['unidad', 'g'],
    icon: '🦴',
    description: 'Premios o golosinas para perros',
    keywords: ['golosina perro', 'premio perro', 'galletitas perro', 'dentastix']
  },
  {
    id: 'prod_m004',
    name: 'Snacks para gatos',
    category: 'mascotas',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'g'],
    icon: '🐟',
    description: 'Premios o golosinas para gatos',
    keywords: ['golosina gato', 'premio gato', 'dreamies']
  },
  {
    id: 'prod_m017',
    name: 'Huesos de cuero',
    category: 'mascotas',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '🦴',
    description: 'Huesos masticables de cuero',
    keywords: ['huesito']
  },

  // HIGIENE Y SANIDAD (GATOS)
  {
    id: 'prod_m005',
    name: 'Arena para gatos',
    category: 'mascotas',
    defaultUnit: 'unidad', // Bolsa
    commonUnits: ['unidad', 'kg'],
    icon: '🪣',
    description: 'Arena sanitaria tradicional',
    keywords: ['arena sanitaria']
  },
  {
    id: 'prod_m016',
    name: 'Piedritas sanitarias',
    category: 'mascotas',
    defaultUnit: 'unidad', // Bolsa
    commonUnits: ['unidad', 'kg'],
    icon: '🪣',
    description: 'Piedritas sanitarias o aglomerantes',
    keywords: ['piedras gato']
  },

  // HIGIENE GENERAL Y VETERINARIA
  {
    id: 'prod_m008',
    name: 'Shampoo para mascotas',
    category: 'mascotas',
    defaultUnit: 'unidad', // Botella
    commonUnits: ['unidad', 'ml', 'l'],
    icon: '🧴',
    description: 'Shampoo o jabón para perros/gatos',
    keywords: ['jabon perro', 'champu perro']
  },
  {
    id: 'prod_m015',
    name: 'Bolsitas higiénicas',
    category: 'mascotas',
    defaultUnit: 'unidad', // Rollito
    commonUnits: ['unidad'],
    icon: '💩',
    description: 'Rollos de bolsas para heces',
    keywords: ['bolsitas caca', 'bolsas perro']
  },
  {
    id: 'prod_m009',
    name: 'Antipulgas',
    category: 'mascotas',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '💊',
    description: 'Pipeta, pastilla o collar antipulgas',
    keywords: ['pipeta', 'collar antipulgas', 'bravecto', 'nexgard', 'frontline']
  },
  {
    id: 'prod_m018',
    name: 'Antiparasitario interno',
    category: 'mascotas',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '💊',
    description: 'Pastillas desparasitantes',
    keywords: ['desparasitante', 'pastilla parasitos']
  },

  // ACCESORIOS Y PASEO
  {
    id: 'prod_m010',
    name: 'Juguetes para mascotas',
    category: 'mascotas',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '🎾',
    description: 'Pelotas, sogas, peluches',
    keywords: ['pelota perro', 'juguete gato']
  },
  {
    id: 'prod_m011',
    name: 'Correa para perros',
    category: 'mascotas',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '🦮',
    description: 'Correa de paseo',
    keywords: ['pretal', 'arnes']
  },
  {
    id: 'prod_m012',
    name: 'Collar',
    category: 'mascotas',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '🐕',
    description: 'Collar para perros o gatos',
    keywords: ['collarcito']
  },
  {
    id: 'prod_m020',
    name: 'Bozal',
    category: 'mascotas',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '🐕',
    description: 'Bozal para perros',
    keywords: []
  },
  {
    id: 'prod_m013',
    name: 'Comedero / Bebedero',
    category: 'mascotas',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '🍽️',
    description: 'Plato para agua o comida',
    keywords: ['plato perro', 'plato gato']
  },

  // DESCANSO Y HOGAR
  {
    id: 'prod_m014',
    name: 'Cama para mascotas',
    category: 'mascotas',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '🛏️',
    description: 'Cama, colchoneta o manta',
    keywords: ['colchoneta perro', 'cucha']
  },
  {
    id: 'prod_m019',
    name: 'Rascador',
    category: 'mascotas',
    defaultUnit: 'unidad',
    commonUnits: ['unidad'],
    icon: '🐈',
    description: 'Rascador o torre para gatos',
    keywords: []
  }
];

// ============================================
// SNACKS Y GOLOSINAS (39 productos) ✅ LIMPIO & OPTIMIZADO PARA BUSCADOR
// ============================================
const SNACKS_GOLOSINAS = [
  // SNACKS SALADOS
  {
    id: 'prod_sg001',
    name: 'Papas fritas',
    category: 'snacks y golosinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'g', 'kg'],
    icon: '🥔',
    description: 'Papas fritas de copetín',
    keywords: ['lays', 'krachitos', 'pehuamar', 'papas de paquete']
  },
  {
    id: 'prod_sg002',
    name: 'Palitos salados',
    category: 'snacks y golosinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'g', 'kg'],
    icon: '🥖',
    description: 'Palitos salados',
    keywords: ['palitos', 'snack']
  },
  {
    id: 'prod_sg023',
    name: 'Chizitos',
    category: 'snacks y golosinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'g', 'kg'],
    icon: '🧀',
    description: 'Snacks de queso horneados',
    keywords: ['cheetos', 'chisitos']
  },
  {
    id: 'prod_sg036', // NUEVO
    name: 'Puflitos',
    category: 'snacks y golosinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'g', 'kg'],
    icon: '🌽',
    description: 'Snack de maíz dulce',
    keywords: ['puflitos dulces']
  },
  {
    id: 'prod_sg005',
    name: 'Nachos',
    category: 'snacks y golosinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'g', 'kg'],
    icon: '🌮',
    description: 'Nachos o tortilla chips',
    keywords: ['doritos']
  },
  {
    id: 'prod_sg031',
    name: 'Saladix / Snacks de panadería',
    category: 'snacks y golosinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'g', 'kg'],
    icon: '🥖',
    description: 'Snacks horneados saborizados',
    keywords: ['saladix', 'kesitas', 'rex']
  },
  {
    id: 'prod_sg003',
    name: 'Maní salado',
    category: 'snacks y golosinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'g', 'kg'],
    icon: '🥜',
    description: 'Maní salado pelado o con cáscara',
    keywords: ['mani japones', 'mani cervecero']
  },

  // CHOCOLATES Y GOLOSINAS
  {
    id: 'prod_sg006',
    name: 'Chocolate en barra',
    category: 'snacks y golosinas',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'g'],
    icon: '🍫',
    description: 'Tableta de chocolate (leche, amargo, blanco)',
    keywords: ['milka', 'aguila', 'cofler', 'tableta de chocolate']
  },
  {
    id: 'prod_sg007',
    name: 'Bombones',
    category: 'snacks y golosinas',
    defaultUnit: 'unidad', // Caja o unidad suelta
    commonUnits: ['unidad', 'caja', 'kg', 'g'],
    icon: '🍬',
    description: 'Bombones surtidos o en caja',
    keywords: ['garoto', 'ferrero', 'caja de bombones']
  },
  {
    id: 'prod_sg034',
    name: 'Bon o Bon',
    category: 'snacks y golosinas',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'caja'],
    icon: '🍫',
    description: 'Bombones Bon o Bon',
    keywords: ['bonobon']
  },
  {
    id: 'prod_sg008',
    name: 'Alfajores',
    category: 'snacks y golosinas',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'caja'],
    icon: '🍪',
    description: 'Alfajores simples, triples o de maicena',
    keywords: ['guaymallen', 'jorjito', 'havanna', 'alfajor']
  },
  {
    id: 'prod_sg032',
    name: 'Mantecol',
    category: 'snacks y golosinas',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'g'],
    icon: '🍫',
    description: 'Postre de maní',
    keywords: ['nucrem']
  },
  {
    id: 'prod_sg027',
    name: 'Rhodesia',
    category: 'snacks y golosinas',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'paquete'],
    icon: '🍫',
    description: 'Oblea Rhodesia',
    keywords: []
  },
  {
    id: 'prod_sg037', // NUEVO (El mellizo)
    name: 'Tita',
    category: 'snacks y golosinas',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'paquete'],
    icon: '🍫',
    description: 'Galletita bañada Tita',
    keywords: []
  },
  {
    id: 'prod_sg017',
    name: 'Conitos de dulce de leche',
    category: 'snacks y golosinas',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'caja'],
    icon: '🍦', // Es lo más parecido a un conito
    description: 'Conitos rellenos',
    keywords: ['havannet']
  },

  // CARAMELOS Y CHICLES
  {
    id: 'prod_sg009',
    name: 'Caramelos',
    category: 'snacks y golosinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'g', 'kg'],
    icon: '🍬',
    description: 'Caramelos duros o masticables (bolsa)',
    keywords: ['bolsa de caramelos', 'flynn paff', 'media hora']
  },
  {
    id: 'prod_sg035',
    name: 'Sugus',
    category: 'snacks y golosinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'unidad'],
    icon: '🍬',
    description: 'Caramelos masticables o confitados Sugus',
    keywords: ['sugus confitados']
  },
  {
    id: 'prod_sg010',
    name: 'Chicles',
    category: 'snacks y golosinas',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'paquete'],
    icon: '🍬',
    description: 'Chicles o goma de mascar',
    keywords: ['beluent', 'topline', 'beldent']
  },
  {
    id: 'prod_sg011',
    name: 'Gomitas',
    category: 'snacks y golosinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'g', 'kg'],
    icon: '🍬',
    description: 'Gomitas de gelatina o eucalipto',
    keywords: ['yummy', 'mogul']
  },
  {
    id: 'prod_sg012',
    name: 'Chupetines',
    category: 'snacks y golosinas',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'paquete'],
    icon: '🍭',
    description: 'Chupetines o paletas',
    keywords: ['pico dulce', 'baby doll']
  },
  {
    id: 'prod_sg024',
    name: 'Pastillas',
    category: 'snacks y golosinas',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'paquete'],
    icon: '🍬',
    description: 'Pastillas de menta, frutales o DRF',
    keywords: ['drf', 'mentho plus', 'halls']
  },
  {
    id: 'prod_sg033',
    name: 'Rocklets / Confites',
    category: 'snacks y golosinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'g', 'kg'],
    icon: '🍬',
    description: 'Confites de chocolate o maní',
    keywords: ['rocklets', 'm&m', 'sugus confitados']
  },

  // GALLETITAS Y CEREALES (Snacks dulces)
  {
    id: 'prod_sg038', // NUEVO (Básico de súper)
    name: 'Galletitas Dulces Surtidas',
    category: 'snacks y golosinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'g'],
    icon: '🍪',
    description: 'Galletitas dulces surtidas o simples',
    keywords: ['surtido bagley', 'terrabusi', 'chocolinas', 'vocacion']
  },
  {
    id: 'prod_sg016',
    name: 'Galletitas rellenas',
    category: 'snacks y golosinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'g'],
    icon: '🍪',
    description: 'Galletitas con relleno dulce',
    keywords: ['oreo', 'merengadas', 'sonrisas', 'rumba', 'amor']
  },
  {
    id: 'prod_sg028',
    name: 'Pepitos / Con chips',
    category: 'snacks y golosinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'g'],
    icon: '🍪',
    description: 'Galletitas con chips de chocolate',
    keywords: ['pepitos', 'toddy']
  },
  {
    id: 'prod_sg039', // NUEVO
    name: 'Galletitas de agua / saladas',
    category: 'snacks y golosinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'g'],
    icon: '🍘',
    description: 'Galletitas de agua o salvado',
    keywords: ['criollitas', 'traviata', 'express']
  },
  {
    id: 'prod_sg019',
    name: 'Bizcochitos',
    category: 'snacks y golosinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'g', 'kg'],
    icon: '🍪',
    description: 'Bizcochitos de grasa o dulces',
    keywords: ['don satur', '9 de oro', 'bizcochos']
  },
  {
    id: 'prod_sg029',
    name: 'Cerealitas / Galletas de cereal',
    category: 'snacks y golosinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'g'],
    icon: '🍪',
    description: 'Galletitas con semillas o integrales',
    keywords: ['cerealitas', 'frutigran']
  },
  {
    id: 'prod_sg015',
    name: 'Barras de cereal',
    category: 'snacks y golosinas',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'caja'],
    icon: '🍫',
    description: 'Barras de cereal individuales o en caja',
    keywords: ['cereal mix', 'turron']
  },
  {
    id: 'prod_sg030',
    name: 'Tutucas',
    category: 'snacks y golosinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'g'],
    icon: '🍿',
    description: 'Maíz inflado azucarado',
    keywords: ['tutuca']
  },
  {
    id: 'prod_sg004',
    name: 'Pochoclos',
    category: 'snacks y golosinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'g'],
    icon: '🍿',
    description: 'Pochoclos dulces o salados',
    keywords: ['palomitas', 'pororo']
  },

  // TURRONES Y MIXES
  {
    id: 'prod_sg020',
    name: 'Turrón de maní',
    category: 'snacks y golosinas',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'paquete'],
    icon: '🍫',
    description: 'Turrón clásico de oblea y maní',
    keywords: ['turron arcor', 'turron misky']
  },
  {
    id: 'prod_sg021',
    name: 'Mix de frutos secos',
    category: 'snacks y golosinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'g', 'kg'],
    icon: '🌰',
    description: 'Mix de nueces, almendras, pasas (Snack)',
    keywords: ['mix tropical', 'mezcla de frutos secos']
  }
];

// ============================================
// CEREALES Y HARINAS (41 productos) ✅ LIMPIO & OPTIMIZADO PARA BUSCADOR
// ============================================
const CEREALES_HARINAS = [
  // ARROZ Y GRANOS
  {
    id: 'prod_ch001',
    name: 'Arroz blanco',
    category: 'cereales y harinas',
    defaultUnit: 'paquete', // Se compra el paquete de 1kg o 500g
    commonUnits: ['paquete', 'kg', 'g'],
    icon: '🍚',
    description: 'Largo fino o doble carolina',
    keywords: ['arroz largo fino', 'gallo', 'lucchetti', 'arroz comun']
  },
  {
    id: 'prod_ch002',
    name: 'Arroz integral',
    category: 'cereales y harinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'kg', 'g'],
    icon: '🍚',
    description: 'Arroz integral',
    keywords: []
  },
  {
    id: 'prod_ch034',
    name: 'Arroz yamaní',
    category: 'cereales y harinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'kg', 'g'],
    icon: '🍚',
    description: 'Arroz yamaní integral',
    keywords: ['yamani']
  },
  {
    id: 'prod_ch035',
    name: 'Arroz basmati / Parboil',
    category: 'cereales y harinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'kg', 'g'],
    icon: '🍚',
    description: 'Arroz que no se pasa',
    keywords: ['arroz gallo oro', 'parboil']
  },
  {
    id: 'prod_ch012',
    name: 'Quinoa',
    category: 'cereales y harinas',
    defaultUnit: 'g', // Se suele comprar en dietéticas
    commonUnits: ['g', 'kg', 'paquete'],
    icon: '🌾',
    description: 'Quinoa blanca o mix',
    keywords: []
  },
  {
    id: 'prod_ch017',
    name: 'Cous cous',
    category: 'cereales y harinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'g', 'kg'],
    icon: '🌾',
    description: 'Cous cous',
    keywords: ['cuscus']
  },

  // FIDEOS SECCOS
  {
    id: 'prod_ch003',
    name: 'Fideos largos',
    category: 'cereales y harinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'kg', 'g'],
    icon: '🍝',
    description: 'Tallarines o spaguetti secos',
    keywords: ['pasta seca', 'spaghetti', 'tallarines', 'matarazzo', 'lucchetti']
  },
  {
    id: 'prod_ch004',
    name: 'Fideos cortos',
    category: 'cereales y harinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'kg', 'g'],
    icon: '🍝',
    description: 'Mostacholes, penne, tirabuzón',
    keywords: ['pasta', 'mostachol', 'tirabuzon', 'moñitos', 'coditos']
  },
  {
    id: 'prod_ch036',
    name: 'Fideos sin gluten',
    category: 'cereales y harinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'kg', 'g'],
    icon: '🍝',
    description: 'Pasta de arroz o maíz',
    keywords: ['fideos sin tacc', 'fideos para celiacos', 'matarazzo sin tacc']
  },

  // PASTAS FRESCAS Y TAPAS
  {
    id: 'prod_ch029',
    name: 'Pastas rellenas',
    category: 'cereales y harinas',
    defaultUnit: 'caja', // Las planchas o cajas
    commonUnits: ['caja', 'kg', 'paquete'],
    icon: '🥟',
    description: 'Ravioles, sorrentinos, capeletis',
    keywords: ['ravioles', 'sorrentinos', 'capeletis', 'pasta fresca']
  },
  {
    id: 'prod_ch030',
    name: 'Ñoquis',
    category: 'cereales y harinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'kg', 'g'],
    icon: '🥟',
    description: 'Ñoquis de papa o sémola',
    keywords: ['ñoquis de papa']
  },
  {
    id: 'prod_ch019',
    name: 'Tapas de empanada',
    category: 'cereales y harinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'docena'],
    icon: '🥟',
    description: 'Horno, freír o criollas',
    keywords: ['discos de empanada', 'la salteña', 'fargo']
  },
  {
    id: 'prod_ch020',
    name: 'Tapas de tarta',
    category: 'cereales y harinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete'],
    icon: '🥧',
    description: 'Pascualina criolla o hojaldre',
    keywords: ['pascualina', 'tapa de pascualina', 'masa de tarta']
  },
  {
    id: 'prod_ch039',
    name: 'Rapiditas / Tortillas',
    category: 'cereales y harinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete'],
    icon: '🫓',
    description: 'Tortillas de harina de trigo (Fajitas)',
    keywords: ['rapiditas', 'fajitas', 'tacos']
  },
  {
    id: 'prod_ch021',
    name: 'Prepizza',
    category: 'cereales y harinas',
    defaultUnit: 'unidad',
    commonUnits: ['unidad', 'paquete'],
    icon: '🍕',
    description: 'Masa de pizza precocida',
    keywords: ['masa de pizza', 'pizza envasada']
  },

  // HARINAS Y POLVOS
  {
    id: 'prod_ch005',
    name: 'Harina 0000',
    category: 'cereales y harinas',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'paquete'],
    icon: '🌾',
    description: 'Harina de trigo refinada',
    keywords: ['harina blanca', 'harina cuatro ceros', 'blancaflor']
  },
  {
    id: 'prod_ch031',
    name: 'Harina leudante',
    category: 'cereales y harinas',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'paquete'],
    icon: '🌾',
    description: 'Harina con polvo de hornear',
    keywords: ['blancaflor leudante', 'harina para bizcochuelo']
  },
  {
    id: 'prod_ch006',
    name: 'Harina integral',
    category: 'cereales y harinas',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'paquete'],
    icon: '🌾',
    description: 'Harina de trigo integral',
    keywords: ['pureza integral']
  },
  {
    id: 'prod_ch041', // NUEVO
    name: 'Fécula de maíz',
    category: 'cereales y harinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'g'],
    icon: '🌾',
    description: 'Almidón de maíz',
    keywords: ['maizena', 'maicena', 'almidon']
  },
  {
    id: 'prod_ch007',
    name: 'Polenta',
    category: 'cereales y harinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'kg', 'g'],
    icon: '🌾',
    description: 'Harina de maíz de cocción rápida',
    keywords: ['harina de maiz', 'polenta magica', 'prestapronta']
  },
  {
    id: 'prod_ch008',
    name: 'Pan rallado / Rebozador',
    category: 'cereales y harinas',
    defaultUnit: 'kg',
    commonUnits: ['kg', 'g', 'paquete'],
    icon: '🍞',
    description: 'Para milanesas',
    keywords: ['rebozador', 'pan molido', 'panko']
  },
  {
    id: 'prod_ch032',
    name: 'Harina de arroz',
    category: 'cereales y harinas',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg', 'paquete'],
    icon: '🌾',
    description: 'Harina de arroz (Sin TACC)',
    keywords: []
  },
  {
    id: 'prod_ch033',
    name: 'Harina de garbanzo',
    category: 'cereales y harinas',
    defaultUnit: 'g',
    commonUnits: ['g', 'kg', 'paquete'],
    icon: '🌾',
    description: 'Harina para fainá',
    keywords: ['faina']
  },
  {
    id: 'prod_ch014',
    name: 'Sémola',
    category: 'cereales y harinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'kg', 'g'],
    icon: '🌾',
    description: 'Sémola de trigo',
    keywords: ['vituina']
  },
  {
    id: 'prod_ch018',
    name: 'Levadura',
    category: 'cereales y harinas',
    defaultUnit: 'unidad', // Sobre o cubito
    commonUnits: ['unidad', 'paquete'],
    icon: '🧪',
    description: 'Levadura fresca (cubo) o seca (sobre)',
    keywords: ['levadura en polvo', 'levadura fresca', 'levex']
  },

  // PANES DE MOLDE / PANADERÍA
  {
    id: 'prod_ch009',
    name: 'Pan lactal blanco',
    category: 'cereales y harinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'unidad'],
    icon: '🍞',
    description: 'Pan de molde blanco',
    keywords: ['pan lactal', 'fargo', 'pan de molde', 'pan de sandwich']
  },
  {
    id: 'prod_ch037',
    name: 'Pan lactal de salvado/semillas',
    category: 'cereales y harinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'unidad'],
    icon: '🍞',
    description: 'Pan integral o con semillas',
    keywords: ['pan negro', 'pan integral', 'pan multicereal']
  },
  {
    id: 'prod_ch010',
    name: 'Pan francés / de panadería',
    category: 'cereales y harinas',
    defaultUnit: 'kg', // Este sí se pide por kilo o medio
    commonUnits: ['kg', 'g', 'unidad'],
    icon: '🥖',
    description: 'Mignon, flautita, roseta',
    keywords: ['baguette', 'mignon', 'pan miñon', 'pan del dia']
  },
  {
    id: 'prod_ch022',
    name: 'Pan de hamburguesa',
    category: 'cereales y harinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete'],
    icon: '🍔',
    description: 'Bolsa de panes para hamburguesas',
    keywords: ['pan de viena', 'pan de burger']
  },
  {
    id: 'prod_ch023',
    name: 'Pan de pancho',
    category: 'cereales y harinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete'],
    icon: '🌭',
    description: 'Bolsa de panes para panchos',
    keywords: ['pan de viena largo', 'pan para hot dog']
  },
  {
    id: 'prod_ch038',
    name: 'Pan árabe / Pita',
    category: 'cereales y harinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'unidad'],
    icon: '🫓',
    description: 'Pan árabe para sandwiches',
    keywords: ['pan pita']
  },

  // DESAYUNO Y MERIENDA
  {
    id: 'prod_ch011',
    name: 'Avena',
    category: 'cereales y harinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete', 'g', 'kg'],
    icon: '🌾',
    description: 'Avena arrollada instantánea o tradicional',
    keywords: ['avena quaker']
  },
  {
    id: 'prod_ch015',
    name: 'Cereales de desayuno',
    category: 'cereales y harinas',
    defaultUnit: 'paquete', // Caja o bolsa
    commonUnits: ['paquete', 'g', 'kg'],
    icon: '🥣',
    description: 'Copos de maíz, azucarados, etc.',
    keywords: ['corn flakes', 'zucaritas', 'copos de maiz']
  },
  {
    id: 'prod_ch016',
    name: 'Granola',
    category: 'cereales y harinas',
    defaultUnit: 'g', // Se compra en dietética
    commonUnits: ['g', 'kg', 'paquete'],
    icon: '🥣',
    description: 'Granola con frutas o miel',
    keywords: []
  },
  {
    id: 'prod_ch024',
    name: 'Tostadas de paquete',
    category: 'cereales y harinas',
    defaultUnit: 'paquete',
    commonUnits: ['paquete'],
    icon: '🍞',
    description: 'Tostadas clásicas o de gluten',
    keywords: ['riera', 'tostadas riera']
  },
  
  // FACTURAS
  {
    id: 'prod_ch025',
    name: 'Medialunas',
    category: 'cereales y harinas',
    defaultUnit: 'docena', // ¡Arg arg arg!
    commonUnits: ['docena', 'unidad'],
    icon: '🥐',
    description: 'Medialunas de manteca o grasa',
    keywords: ['facturas']
  },
  {
    id: 'prod_ch026',
    name: 'Facturas surtidas',
    category: 'cereales y harinas',
    defaultUnit: 'docena',
    commonUnits: ['docena', 'unidad'],
    icon: '🥐',
    description: 'Facturas de panadería',
    keywords: ['vigilantes', 'churros']
  },
  {
    id: 'prod_ch040',
    name: 'Bizcochos de grasa',
    category: 'cereales y harinas',
    defaultUnit: 'g', // Panadería ("dame 200 de bizcochos")
    commonUnits: ['g', 'kg', 'paquete'],
    icon: '🥐',
    description: 'Bizcochitos de panadería',
    keywords: ['cuernitos', 'libritos']
  }
];


// ============================================
// DESPENSA / ALMACÉN (66 productos) ✅ LIMPIO & OPTIMIZADO PARA BUSCADOR
// ============================================
const DESPENSA = [
  // ACEITES Y VINAGRES
  { id: 'prod_d001', name: 'Aceite de girasol', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad', 'l', 'ml'], icon: '🛢️', description: 'Aceite de girasol botella', keywords: ['aceite natura', 'aceite cocinero', 'aceite comun'] },
  { id: 'prod_d061', name: 'Aceite de maíz / mezcla', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad', 'l', 'ml'], icon: '🛢️', description: 'Aceite de maíz o mezcla', keywords: ['aceite mezcla'] },
  { id: 'prod_d002', name: 'Aceite de oliva', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad', 'l', 'ml'], icon: '🫒', description: 'Aceite de oliva extra virgen', keywords: ['oliva', 'aceite de oliva'] },
  { id: 'prod_d008', name: 'Vinagre', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad', 'l', 'ml'], icon: '🧪', description: 'Vinagre de alcohol o manzana', keywords: ['vinagre de alcohol', 'vinagre de manzana', 'vinagre de vino'] },
  { id: 'prod_d062', name: 'Aceto balsámico', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad', 'ml'], icon: '🧪', description: 'Aceto balsámico', keywords: ['aceto'] },
  { id: 'prod_d063', name: 'Jugo de limón', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad', 'ml'], icon: '🍋', description: 'Jugo de limón envasado', keywords: ['minerva', 'limon en botella'] },

  // ADEREZOS Y SALSAS
  { id: 'prod_d009', name: 'Mayonesa', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad', 'g', 'kg'], icon: '🥫', description: 'Mayonesa en sachet o frasco', keywords: ['natura', 'hellmanns', 'mayonesa light'] },
  { id: 'prod_d010', name: 'Ketchup', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad', 'g'], icon: '🥫', description: 'Ketchup', keywords: ['salsa ketchup', 'catchup'] },
  { id: 'prod_d011', name: 'Mostaza', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad', 'g'], icon: '🥫', description: 'Mostaza común o savora', keywords: ['savora'] },
  { id: 'prod_d059', name: 'Salsa golf', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad', 'g'], icon: '🥫', description: 'Salsa golf argentina', keywords: ['golf'] },
  { id: 'prod_d012', name: 'Salsa de soja', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad', 'ml'], icon: '🥫', description: 'Salsa de soja', keywords: ['soja'] },
  { id: 'prod_d013', name: 'Salsa picante', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad', 'ml'], icon: '🌶️', description: 'Salsa picante o tabasco', keywords: ['tabasco', 'salsa de aji'] },
  { id: 'prod_d060', name: 'Aderezo para ensaladas', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad', 'ml'], icon: '🥗', description: 'Aderezo césar, ranch, etc.', keywords: ['salsa cesar'] },

  // AZÚCAR, SAL Y ENDULZANTES
  { id: 'prod_d003', name: 'Sal fina', category: 'despensa', defaultUnit: 'paquete', commonUnits: ['paquete', 'kg', 'g'], icon: '🧂', description: 'Sal fina de mesa', keywords: ['celusal', 'sal comun'] },
  { id: 'prod_d004', name: 'Sal gruesa / parrillera', category: 'despensa', defaultUnit: 'paquete', commonUnits: ['paquete', 'kg', 'g'], icon: '🧂', description: 'Sal gruesa o parrillera', keywords: ['sal parrillera', 'sal entrefina'] },
  { id: 'prod_d005', name: 'Azúcar blanca', category: 'despensa', defaultUnit: 'kg', commonUnits: ['kg', 'paquete'], icon: '🍚', description: 'Azúcar blanca común', keywords: ['ledesma', 'azucar comun'] },
  { id: 'prod_d006', name: 'Azúcar negra / rubia', category: 'despensa', defaultUnit: 'paquete', commonUnits: ['paquete', 'kg', 'g'], icon: '🍚', description: 'Azúcar mascabo, negra o rubia', keywords: ['mascabo', 'azucar rubia'] },
  { id: 'prod_d007', name: 'Edulcorante', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad'], icon: '💧', description: 'Edulcorante líquido o en sobres', keywords: ['hileret', 'sucralosa', 'stevia'] },

  // DULCES Y MERMELADAS
  { id: 'prod_d022', name: 'Mermelada', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad', 'g'], icon: '🍯', description: 'Mermelada de frutas', keywords: ['arcor', 'mermelada de durazno', 'mermelada de frutilla'] },
  { id: 'prod_d023', name: 'Miel', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad', 'kg', 'g'], icon: '🍯', description: 'Miel líquida o sólida', keywords: ['frasco de miel'] },
  { id: 'prod_d024', name: 'Dulce de leche', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad', 'kg', 'g'], icon: '🍯', description: 'Familiar o repostero', keywords: ['ddl', 'repostero', 'colonial'] },
  { id: 'prod_d041', name: 'Dulce de batata', category: 'despensa', defaultUnit: 'paquete', commonUnits: ['paquete', 'kg', 'g'], icon: '🍠', description: 'Lata o cajita', keywords: ['batata', 'postre'] },
  { id: 'prod_d042', name: 'Dulce de membrillo', category: 'despensa', defaultUnit: 'paquete', commonUnits: ['paquete', 'kg', 'g'], icon: '🍎', description: 'Lata o cajita', keywords: ['membrillo'] },
  { id: 'prod_d043', name: 'Arrope', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad', 'g'], icon: '🍯', description: 'Arrope de uva o algarroba', keywords: [] },

  // CONSERVAS DE TOMATE
  { id: 'prod_d014', name: 'Puré de tomate', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad', 'caja'], icon: '🍅', description: 'Puré de tomate (cajita/botella)', keywords: ['salsa de tomate', 'cajita de pure'] },
  { id: 'prod_d048', name: 'Extracto de tomate', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad', 'lata'], icon: '🍅', description: 'Extracto de tomate concentrado', keywords: ['lata de extracto'] },
  { id: 'prod_d016', name: 'Tomate triturado', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad', 'botella', 'lata'], icon: '🍅', description: 'Tomate perita triturado o entero', keywords: ['tomate en lata', 'tomate perita en lata'] },
  { id: 'prod_d015', name: 'Salsa de tomate lista', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad', 'paquete'], icon: '🍅', description: 'Salsa fileto, pomarola, pizza', keywords: ['pomarola', 'fileto', 'salsa para pizza', 'salsa lista'] },

  // CONSERVAS VARIAS Y PICADAS
  { id: 'prod_d020', name: 'Aceitunas', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad', 'g'], icon: '🫒', description: 'Aceitunas verdes o negras', keywords: ['frasco de aceitunas', 'aceitunas descarozadas'] },
  { id: 'prod_d019', name: 'Pickles / Pepinillos', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad'], icon: '🥒', description: 'Pickles en vinagre', keywords: ['pepinillos'] },
  { id: 'prod_d017', name: 'Arvejas enlatadas', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad', 'lata', 'caja'], icon: '🥫', description: 'Arvejas en lata o tetrapack', keywords: ['lata de arvejas'] },
  { id: 'prod_d018', name: 'Choclo enlatado', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad', 'lata'], icon: '🌽', description: 'Choclo en grano o cremoso', keywords: ['lata de choclo', 'choclo cremoso'] },
  { id: 'prod_d021', name: 'Atún enlatado', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad', 'lata'], icon: '🥫', description: 'Atún al natural o en aceite', keywords: ['lata de atun', 'lomitos de atun'] },

  // FRUTOS SECOS (Si se buscan en despensa)
  { id: 'prod_d026', name: 'Maní', category: 'despensa', defaultUnit: 'g', commonUnits: ['g', 'kg'], icon: '🥜', description: 'Maní pelado', keywords: ['mani sin sal'] },
  { id: 'prod_d027', name: 'Almendras', category: 'despensa', defaultUnit: 'g', commonUnits: ['g', 'kg'], icon: '🌰', description: 'Almendras', keywords: [] },
  { id: 'prod_d028', name: 'Nueces', category: 'despensa', defaultUnit: 'g', commonUnits: ['g', 'kg'], icon: '🌰', description: 'Nueces peladas o con cáscara', keywords: ['nuez mariposa'] },
  { id: 'prod_d029', name: 'Pasas de uva', category: 'despensa', defaultUnit: 'g', commonUnits: ['g', 'kg'], icon: '🍇', description: 'Pasas rubias o negras', keywords: ['pasas de uva rubias'] },

  // ESPECIAS Y CONDIMENTOS
  { id: 'prod_d031', name: 'Especias varias', category: 'despensa', defaultUnit: 'paquete', commonUnits: ['paquete', 'g'], icon: '🌶️', description: 'Condimento para pizza, tucos, etc.', keywords: ['alicante', 'condimento para arroz', 'especias surtidas'] },
  { id: 'prod_d032', name: 'Laurel', category: 'despensa', defaultUnit: 'paquete', commonUnits: ['paquete', 'g'], icon: '🌿', description: 'Hojas de laurel secas', keywords: ['hojas de laurel'] },
  { id: 'prod_d033', name: 'Comino', category: 'despensa', defaultUnit: 'paquete', commonUnits: ['paquete', 'g'], icon: '🌶️', description: 'Comino molido o en grano', keywords: ['comino molido'] },
  { id: 'prod_d034', name: 'Pimentón', category: 'despensa', defaultUnit: 'paquete', commonUnits: ['paquete', 'g'], icon: '🌶️', description: 'Pimentón dulce o extra', keywords: ['pimenton dulce'] },
  { id: 'prod_d047', name: 'Pimentón ahumado', category: 'despensa', defaultUnit: 'paquete', commonUnits: ['paquete', 'g'], icon: '🌶️', description: 'Pimentón ahumado', keywords: [] },
  { id: 'prod_d035', name: 'Orégano', category: 'despensa', defaultUnit: 'paquete', commonUnits: ['paquete', 'g'], icon: '🌿', description: 'Orégano seco', keywords: [] },
  { id: 'prod_d036', name: 'Pimienta', category: 'despensa', defaultUnit: 'paquete', commonUnits: ['paquete', 'g'], icon: '⚫', description: 'Pimienta negra o blanca', keywords: ['pimienta negra', 'pimienta blanca', 'pimienta en grano'] },
  { id: 'prod_d044', name: 'Chimichurri seco', category: 'despensa', defaultUnit: 'paquete', commonUnits: ['paquete', 'g'], icon: '🌿', description: 'Condimento chimichurri', keywords: ['chimi'] },
  { id: 'prod_d045', name: 'Provenzal', category: 'despensa', defaultUnit: 'paquete', commonUnits: ['paquete', 'g'], icon: '🌿', description: 'Ajo y perejil deshidratado', keywords: ['ajo y perejil'] },
  { id: 'prod_d046', name: 'Ají molido', category: 'despensa', defaultUnit: 'paquete', commonUnits: ['paquete', 'g'], icon: '🌶️', description: 'Ají molido picante', keywords: [] },
  { id: 'prod_d049', name: 'Hongos secos', category: 'despensa', defaultUnit: 'paquete', commonUnits: ['paquete', 'g'], icon: '🍄', description: 'Hongos deshidratados (pino)', keywords: ['hongos de pino'] },
  { id: 'prod_d050', name: 'Cebolla en polvo/escamas', category: 'despensa', defaultUnit: 'paquete', commonUnits: ['paquete', 'g'], icon: '🧅', description: 'Cebolla deshidratada', keywords: ['cebolla deshidratada'] },
  { id: 'prod_d051', name: 'Ajo en polvo/escamas', category: 'despensa', defaultUnit: 'paquete', commonUnits: ['paquete', 'g'], icon: '🧄', description: 'Ajo deshidratado', keywords: ['ajo deshidratado'] },

  // REPOSTERÍA Y POSTRES
  { id: 'prod_d064', name: 'Esencia de vainilla', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad', 'ml'], icon: '🧴', description: 'Extracto o esencia líquida', keywords: ['vainilla liquida'] },
  { id: 'prod_d039', name: 'Polvo para hornear', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad', 'g'], icon: '🧪', description: 'Polvo de hornear', keywords: ['royal', 'levadura quimica'] },
  { id: 'prod_d040', name: 'Bicarbonato de sodio', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad', 'g'], icon: '🧪', description: 'Bicarbonato', keywords: [] },
  { id: 'prod_d052', name: 'Gelatina sin sabor', category: 'despensa', defaultUnit: 'paquete', commonUnits: ['paquete', 'g'], icon: '🧊', description: 'Gelatina neutra', keywords: ['gelatina neutra'] },
  { id: 'prod_d053', name: 'Gelatina con sabor', category: 'despensa', defaultUnit: 'paquete', commonUnits: ['paquete', 'g'], icon: '🍮', description: 'Cajas de gelatina de frutas', keywords: ['gelatina royal', 'gelatina godet'] },
  { id: 'prod_d054', name: 'Flan en polvo', category: 'despensa', defaultUnit: 'paquete', commonUnits: ['paquete', 'g'], icon: '🍮', description: 'Flan para preparar', keywords: ['flan royal', 'flan de vainilla', 'postre en polvo'] },

  // COMIDAS PREPARADAS Y CALDOS
  { id: 'prod_d030', name: 'Caldo en cubo', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad', 'caja'], icon: '🧊', description: 'Caldo de gallina, carne o verdura', keywords: ['cubito de caldo', 'knorr', 'maggi', 'caldo de verduras'] },
  { id: 'prod_d055', name: 'Maíz blanco / Mazamorra', category: 'despensa', defaultUnit: 'paquete', commonUnits: ['paquete', 'g', 'kg'], icon: '🌽', description: 'Maíz blanco partido o entero', keywords: ['maiz para locro', 'mazamorra'] },
  { id: 'prod_d056', name: 'Humita enlatada', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad', 'lata'], icon: '🌽', description: 'Humita en chala en lata', keywords: ['lata de humita'] },
  { id: 'prod_d057', name: 'Locro enlatado', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad', 'lata'], icon: '🥫', description: 'Locro listo en lata', keywords: ['lata de locro'] },
  { id: 'prod_d058', name: 'Guiso enlatado', category: 'despensa', defaultUnit: 'unidad', commonUnits: ['unidad', 'lata'], icon: '🥫', description: 'Mondongo o guiso de lentejas', keywords: ['mondongo en lata', 'guiso de lentejas lata'] },
];

// ============================================
// CONGELADOS (28 productos) ✅ LIMPIO & OPTIMIZADO PARA BUSCADOR
// ============================================
const CONGELADOS = [
  // VEGETALES Y PAPAS
  { id: 'prod_co002', name: 'Papas congeladas', category: 'congelados', defaultUnit: 'paquete', commonUnits: ['paquete', 'kg', 'g'], icon: '🍟', description: 'Papas bastón prefritas', keywords: ['mccain', 'papas fritas congeladas'] },
  { id: 'prod_co021', name: 'Papas noisette', category: 'congelados', defaultUnit: 'paquete', commonUnits: ['paquete', 'kg', 'g'], icon: '🥔', description: 'Papas noisette o caritas', keywords: ['caritas de papa', 'smiles', 'mccain noisette'] },
  { id: 'prod_co005', name: 'Mix de verduras', category: 'congelados', defaultUnit: 'paquete', commonUnits: ['paquete', 'kg', 'g'], icon: '🥦', description: 'Mix de vegetales congelados', keywords: ['verdura congelada', 'wok de vegetales'] },
  { id: 'prod_co010', name: 'Arvejas congeladas', category: 'congelados', defaultUnit: 'paquete', commonUnits: ['paquete', 'kg', 'g'], icon: '🫛', description: 'Bolsa de arvejas congeladas', keywords: ['granja del sol'] },
  { id: 'prod_co011', name: 'Choclo congelado', category: 'congelados', defaultUnit: 'paquete', commonUnits: ['paquete', 'kg', 'g'], icon: '🌽', description: 'Choclo en grano congelado', keywords: ['granos de choclo'] },
  { id: 'prod_co019', name: 'Brócoli congelado', category: 'congelados', defaultUnit: 'paquete', commonUnits: ['paquete', 'kg', 'g'], icon: '🥦', description: 'Flores de brócoli congelado', keywords: [] },
  { id: 'prod_co020', name: 'Coliflor congelada', category: 'congelados', defaultUnit: 'paquete', commonUnits: ['paquete', 'kg', 'g'], icon: '🥦', description: 'Coliflor congelada', keywords: [] },
  { id: 'prod_co026', name: 'Espinaca congelada', category: 'congelados', defaultUnit: 'paquete', commonUnits: ['paquete', 'kg', 'g'], icon: '🥬', description: 'Espinaca en porciones', keywords: ['acelga congelada', 'granja del sol'] }, // NUEVO

  // CARNES, POLLO Y PESCADO (REBOZADOS Y CRUDOS)
{ 
    id: 'prod_co001', 
    name: 'Hamburguesas', 
    category: 'carnes', // o 'congelados', según donde lo hayas puesto
    defaultUnit: 'unidad', // 👈 Se pueden pedir sueltas en carnicería o por caja
    commonUnits: ['unidad', 'caja', 'kg'], 
    icon: '🍔', 
    description: 'Hamburguesas de carne o cerdo', 
    keywords: ['paty', 'swift', 'medallones de carne', 'union ganadera'] 
  },
    { id: 'prod_co008', name: 'Milanesas de soja', category: 'congelados', defaultUnit: 'caja', commonUnits: ['caja', 'paquete', 'unidad'], icon: '🥩', description: 'Milanesas de soja o vegetales', keywords: ['lucchetti', 'granja del sol', 'vegetalex', 'medallones de soja'] }, // Ajustado para diferenciar de la carne fresca
  { id: 'prod_co009', name: 'Nuggets de pollo', category: 'congelados', defaultUnit: 'paquete', commonUnits: ['paquete', 'kg', 'g'], icon: '🍗', description: 'Nuggets o formitas', keywords: ['patitas', 'granja del sol', 'sadia', 'formitas de pollo'] },
  { id: 'prod_co007', name: 'Palitos de pescado', category: 'congelados', defaultUnit: 'caja', commonUnits: ['caja', 'paquete'], icon: '🐟', description: 'Palitos o medallones de pescado', keywords: ['merluza rebozada'] },
  { id: 'prod_co014', name: 'Filet de pescado', category: 'congelados', defaultUnit: 'kg', commonUnits: ['kg', 'paquete', 'g'], icon: '🐟', description: 'Filetes de merluza, brótola', keywords: ['pescado congelado', 'filet congelado'] },

  // PASTAS, PIZZAS Y COMIDAS LISTAS
  { id: 'prod_co003', name: 'Pizza congelada', category: 'congelados', defaultUnit: 'unidad', commonUnits: ['unidad'], icon: '🍕', description: 'Pizza lista congelada', keywords: ['sibarita'] },
  { id: 'prod_co004', name: 'Empanadas congeladas', category: 'congelados', defaultUnit: 'caja', commonUnits: ['caja', 'docena', 'unidad'], icon: '🥟', description: 'Empanadas listas para hornear', keywords: ['empanadas el noble'] },
  { id: 'prod_co018', name: 'Tartas congeladas', category: 'congelados', defaultUnit: 'unidad', commonUnits: ['unidad'], icon: '🥧', description: 'Tartas individuales o grandes', keywords: ['tarta lista'] },
  { id: 'prod_co016', name: 'Sorrentinos congelados', category: 'congelados', defaultUnit: 'caja', commonUnits: ['caja', 'paquete', 'kg'], icon: '🥟', description: 'Sorrentinos o ravioles', keywords: ['pasta congelada'] },
  { id: 'prod_co017', name: 'Ñoquis congelados', category: 'congelados', defaultUnit: 'paquete', commonUnits: ['paquete', 'kg'], icon: '🥟', description: 'Ñoquis listos para hervir', keywords: [] },
  { id: 'prod_co025', name: 'Canelones congelados', category: 'congelados', defaultUnit: 'caja', commonUnits: ['caja', 'unidad'], icon: '🥟', description: 'Canelones listos', keywords: [] },
  
  // PICADAS Y FRITURAS
  { id: 'prod_co022', name: 'Bastones de muzzarella', category: 'congelados', defaultUnit: 'paquete', commonUnits: ['paquete', 'g'], icon: '🧀', description: 'Bastones de muzzarella rebozados', keywords: ['mozzarella rebozada'] },
  { id: 'prod_co023', name: 'Aros de cebolla', category: 'congelados', defaultUnit: 'paquete', commonUnits: ['paquete', 'g'], icon: '🧅', description: 'Aros de cebolla rebozados', keywords: ['cebolla rebozada'] },
  { id: 'prod_co024', name: 'Mariscos rebozados', category: 'congelados', defaultUnit: 'paquete', commonUnits: ['paquete', 'g', 'kg'], icon: '🍤', description: 'Rabas, langostinos, calamares', keywords: ['rabas congeladas', 'minutas de mar'] },

  // FRUTAS Y POSTRES
  { id: 'prod_co006', name: 'Helado', category: 'congelados', defaultUnit: 'l', commonUnits: ['l', 'kg', 'pote'], icon: '🍦', description: 'Helado en pote o caja', keywords: ['pote de helado'] },
  { id: 'prod_co012', name: 'Frutillas congeladas', category: 'congelados', defaultUnit: 'paquete', commonUnits: ['paquete', 'kg', 'g'], icon: '🍓', description: 'Bolsa de frutillas', keywords: [] },
  { id: 'prod_co027', name: 'Mix de frutos rojos', category: 'congelados', defaultUnit: 'paquete', commonUnits: ['paquete', 'kg', 'g'], icon: '🫐', description: 'Arándanos, moras, frambuesas', keywords: ['frutos del bosque congelados'] }, // NUEVO
  { id: 'prod_co013', name: 'Pulpa de frutas', category: 'congelados', defaultUnit: 'paquete', commonUnits: ['paquete', 'kg', 'g'], icon: '🍑', description: 'Pulpa para jugos o licuados', keywords: ['pulpa congelada'] },

  // OTROS (Mantengo este, aunque suele ir en despensa)
  { id: 'prod_co015', name: 'Pochoclos para microondas', category: 'congelados', defaultUnit: 'paquete', commonUnits: ['paquete', 'unidad'], icon: '🍿', description: 'Caja de pochoclos', keywords: ['palomitas', 'popcorn', 'pochoclo microondas'] }
];

// ============================================
// CATÁLOGO COMPLETO - EXPORT FINAL
// ============================================
export const PRODUCT_CATALOG = [
  ...VERDURAS,
  ...CARNES,
  ...FIAMBRES,
  ...LEGUMBRES,
  ...FRUTAS,
  ...BEBIDAS,
  ...LACTEOS,
  ...HUEVOS,
  ...LIMPIEZA_HOGAR,
  ...HIGIENE_PERSONAL,
  ...MASCOTAS,
  ...SNACKS_GOLOSINAS,
  ...CEREALES_HARINAS,
  ...DESPENSA,
  ...CONGELADOS
];

// Índice por categorías
export const PRODUCTS_BY_CATEGORY = {
  verduras: VERDURAS,
  carnes: CARNES,
  fiambres: FIAMBRES,
  legumbres: LEGUMBRES,
  frutas: FRUTAS,
  bebidas: BEBIDAS,
  lácteos: LACTEOS,
  huevos: HUEVOS,
  'limpieza del hogar': LIMPIEZA_HOGAR,
  'higiene personal': HIGIENE_PERSONAL,
  mascotas: MASCOTAS,
  'snacks y golosinas': SNACKS_GOLOSINAS,
  'cereales y harinas': CEREALES_HARINAS,
  despensa: DESPENSA,
  congelados: CONGELADOS
};

// Categorías disponibles
export const CATEGORIES = [
  'verduras',
  'carnes',
  'fiambres',
  'legumbres',
  'frutas',
  'bebidas',
  'lácteos',
  'huevos',
  'limpieza del hogar',
  'higiene personal',
  'mascotas',
  'snacks y golosinas',
  'cereales y harinas',
  'despensa',
  'congelados'
];

// Total de productos
export const TOTAL_PRODUCTS = PRODUCT_CATALOG.length;

// Funciones auxiliares
export const searchProducts = (query) => {
  const q = query.toLowerCase().trim();
  return PRODUCT_CATALOG.filter(product => 
    product.name.toLowerCase().includes(q) ||
    product.description.toLowerCase().includes(q) ||
    product.keywords?.some(k => k.toLowerCase().includes(q))
  );
};

export const getProductsByCategory = (category) => {
  return PRODUCTS_BY_CATEGORY[category] || [];
};

export const getProductById = (id) => {
  return PRODUCT_CATALOG.find(p => p.id === id);
};

export default {
  PRODUCT_CATALOG,
  PRODUCTS_BY_CATEGORY,
  CATEGORIES,
  TOTAL_PRODUCTS,
  searchProducts,
  getProductsByCategory,
  getProductById
};

console.log(`✅ Catálogo v3.0 CLEAN cargado: ${TOTAL_PRODUCTS} productos`);